import { AspectMap, MatchesRequiredAspects } from "./aspects";

export interface Item extends AspectMap {
  id: string;
  label: string;
  location?: string;

  /** What id spawns if you consider an item. */
  consider_spawn_id?: string;
  fatigues?: string;
}

export function GetItemById(id: string, items = Items) {
  return items.find((item) => item.id == id);
}

export function GetItemsByConsiderSpawnId(id: string, items = Items): Item[] {
  return items.filter((i) => i.consider_spawn_id == id);
}

/** Returns items that match at least one of the required aspects. */
export function GetItemsByAspects(aspects: AspectMap, items = Items) {
  return items.filter((item) => MatchesRequiredAspects(aspects, item));
}

export function GetMatchingItems(
  required: AspectMap,
  essential?: AspectMap,
  items = Items,
) {
  const matchRequiredAspects = GetItemsByAspects(required, items);
  if (essential) return GetItemsByAspects(essential, matchRequiredAspects);
  return matchRequiredAspects;
}

export const Items: Item[] = [
  {
    id: "dog.hungry",
    label: "Hungry Dog",
    uniquenessgroup: "uqdog",
    "dog.hungry": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "dog.tame",
    label: "Loyal Dog",
    uniquenessgroup: "uqdog",
    "dog.tame": 1,
    cooperative: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 2,
    "boost.heart": 2,
    scale: 2,
    "boost.scale": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "dog.hungry",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "dog.wild",
    label: "Stray Dog",
    uniquenessgroup: "uqdog",
    "dog.wild": 1,
    edge: 2,
    "boost.edge": 2,
    heart: 2,
    "boost.heart": 2,
    scale: 2,
    "boost.scale": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "gull.hungry",
    label: "Hungry Gull",
    "gull.hungry": 1,
    moon: 1,
    "boost.moon": 1,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "gull.tame",
    label: "Pet Gull",
    "gull.tame": 1,
    cooperative: 1,
    moon: 1,
    "boost.moon": 1,
    sky: 2,
    "boost.sky": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "gull.hungry",
    consider_spawn_id: "mem.sound",
  },
  {
    id: "gull.wild",
    label: "Orphaned Chick",
    "gull.wild": 1,
    moon: 1,
    "boost.moon": 1,
    sky: 2,
    "boost.sky": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "relic.hungry",
    label: "Hungry Relic",
    "relic.hungry": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 4,
    "boost.scale": 4,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "relic.living",
    label: "Living Relic",
    "relic.living": 1,
    cooperative: 1,
    heart: 1,
    "boost.heart": 1,
    scale: 4,
    "boost.scale": 4,
    sky: 2,
    "boost.sky": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "relic.hungry",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "savage.relic",
    label: "Savage Relic",
    "savage.relic": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 4,
    "boost.scale": 4,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stymphling",
    label: "Stymphling",
    stymphling: 1,
    cooperative: 1,
    moon: 3,
    "boost.moon": 3,
    scale: 3,
    "boost.scale": 3,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "stymphling.hungry",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stymphling.hungry",
    label: "Hungry Stymphling",
    "stymphling.hungry": 1,
    moon: 3,
    "boost.moon": 3,
    scale: 3,
    "boost.scale": 3,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "cat.hungry",
    label: "Unimpressed Cat",
    uniquenessgroup: "uqcat",
    "cat.hungry": 1,
    grail: 1,
    "boost.grail": 1,
    moth: 1,
    "boost.moth": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "cat.tame",
    label: "Pet Cat",
    uniquenessgroup: "uqcat",
    "cat.tame": 1,
    cooperative: 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    moth: 2,
    "boost.moth": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "cat.hungry",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "cat.wild",
    label: "Stray Cat",
    uniquenessgroup: "uqcat",
    "cat.wild": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    moth: 2,
    "boost.moth": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "viper.hungry",
    label: "Hungry Viper",
    "viper.hungry": 1,
    knock: 1,
    "boost.knock": 1,
    scale: 1,
    "boost.scale": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "viper.tame",
    label: "Tame Viper",
    "viper.tame": 1,
    cooperative: 1,
    knock: 2,
    "boost.knock": 2,
    scale: 2,
    "boost.scale": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "viper.hungry",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "viper.wild",
    label: "Wild Viper",
    "viper.wild": 1,
    knock: 2,
    "boost.knock": 2,
    scale: 2,
    "boost.scale": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "chicken.terrence",
    label: "Terrence, the Chicken",
    uniquenessgroup: "uqterrence",
    "chicken.terrence": 1,
    cooperative: 1,
    scale: 3,
    "boost.scale": 3,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "chicken.terrence.hungry",
    consider_spawn_id: "mem.sound",
  },
  {
    id: "chicken.terrence.hungry",
    label: "Resentful Terrence",
    uniquenessgroup: "uqterrence",
    "chicken.terrence.hungry": 1,
    scale: 3,
    "boost.scale": 3,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "chicken.tuppence",
    label: "Tuppence, the Other Chicken",
    uniquenessgroup: "uqtuppence",
    "chicken.tuppence": 1,
    cooperative: 1,
    scale: 2,
    "boost.scale": 2,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "chicken.tuppence.hungry",
    consider_spawn_id: "mem.sound",
  },
  {
    id: "chicken.tuppence.hungry",
    label: "Pleading Tuppence",
    uniquenessgroup: "uqtuppence",
    "chicken.tuppence.hungry": 1,
    scale: 2,
    "boost.scale": 2,
    sky: 1,
    "boost.sky": 1,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "cockatoo.green",
    label: "Magnificent Green Cockatoo",
    uniquenessgroup: "uqchaq",
    "cockatoo.green": 1,
    cooperative: 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    sky: 2,
    "boost.sky": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "cockatoo.green.hungry",
    consider_spawn_id: "mem.sound",
  },
  {
    id: "cockatoo.green.hungry",
    label: " ",
    uniquenessgroup: "uqchaq",
    "cockatoo.green.hungry": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    sky: 2,
    "boost.sky": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "imago.hungry",
    label: "Hungry Imago",
    "imago.hungry": 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    moth: 6,
    "boost.moth": 6,
    scale: 2,
    "boost.scale": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "imago.perilous",
    label: "Perilous Imago",
    "imago.perilous": 1,
    cooperative: 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    moth: 6,
    "boost.moth": 6,
    scale: 2,
    "boost.scale": 2,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "imago.hungry",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "larva.chimeric",
    label: "Chimeric Larva",
    "larva.chimeric": 1,
    cooperative: 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    moth: 4,
    "boost.moth": 4,
    beast: 1,
    considerable: 1,
    comfort: 1,
    fatigues: "larva.hungry",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "larva.hungry",
    label: "Hungry Larva",
    "larva.hungry": 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    moth: 4,
    "boost.moth": 4,
    beast: 1,
    considerable: 1,
    comfort: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "alembic.sly",
    label: "Sly Alembic",
    "alembic.sly": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 3,
    "boost.grail": 3,
    heart: 3,
    "boost.heart": 3,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "assam.sweetened",
    label: "Deep-Sweetened Assam (Pot)",
    "assam.sweetened": 1,
    distributable: 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "assam.sweetened.cup",
    label: "Deep-Sweetened Assam (Cup)",
    "assam.sweetened.cup": 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "assam.sweetened.h",
    label: "Deep-Sweetened Assam (Half-Pot)",
    "assam.sweetened.h": 1,
    distributable: 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "bottle.armagnac",
    label: "Armagnac d'Ys (Bottle)",
    "bottle.armagnac": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.armagnac.me",
    label: "Armagnac d'Ys (Mostly Empty)",
    "bottle.armagnac.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.armagnac.mf",
    label: "Armagnac d'Ys (Mostly Full)",
    "bottle.armagnac.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.blackdove",
    label: "Black Dove Wine",
    "bottle.blackdove": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 4,
    "boost.grail": 4,
    heart: 4,
    "boost.heart": 4,
    moon: 4,
    "boost.moon": 4,
    nectar: 4,
    "boost.nectar": 4,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "old.moment",
  },
  {
    id: "bottle.dandelionwine",
    label: "Dandelion Wine",
    "bottle.dandelionwine": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.dandelionwine.me",
    label: "Dandelion Wine (Mostly Empty)",
    "bottle.dandelionwine.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.dandelionwine.mf",
    label: "Dandelion Wine (Mostly Full)",
    "bottle.dandelionwine.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.jannings",
    label: "Schloss Jannings (Bottle)",
    "bottle.jannings": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.jannings.me",
    label: "Schloss Jannings (Mostly Empty)",
    "bottle.jannings.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.jannings.mf",
    label: "Schloss Jannings (Mostly Full)",
    "bottle.jannings.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.lambig",
    label: "Lambig Broceliande (Bottle)",
    "bottle.lambig": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.lambig.me",
    label: "Lambig Broceliande (Mostly Empty)",
    "bottle.lambig.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.lambig.mf",
    label: "Lambig Broceliande (Mostly Full)",
    "bottle.lambig.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.roscraggan",
    label: "Roscraggan Whisky (Bottle)",
    "bottle.roscraggan": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    rose: 2,
    "boost.rose": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.roscraggan.me",
    label: "Roscraggan Whisky (Mostly Empty)",
    "bottle.roscraggan.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    rose: 2,
    "boost.rose": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.roscraggan.mf",
    label: "Roscraggan Whisky (Mostly Full)",
    "bottle.roscraggan.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    rose: 2,
    "boost.rose": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.sloegin",
    label: "Sloe Gin (Bottle)",
    "bottle.sloegin": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.sloegin.me",
    label: "Sloe Gin (Mostly Empty)",
    "bottle.sloegin.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.sloegin.mf",
    label: "Sloe Gin (Mostly Full)",
    "bottle.sloegin.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.strathcoyne",
    label: "Strathcoyne Whisky (Bottle)",
    "bottle.strathcoyne": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 2,
    "boost.scale": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.strathcoyne.me",
    label: "Strathcoyne Whisky (Mostly Empty)",
    "bottle.strathcoyne.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 2,
    "boost.scale": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.strathcoyne.mf",
    label: "Strathcoyne Whisky (Mostly Full)",
    "bottle.strathcoyne.mf": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 2,
    "boost.scale": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "chalice.lambig",
    label: "Lambig Broceliande (Chalice)",
    "chalice.lambig": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cordial.elderflower",
    label: "Elderflower Cordial",
    "cordial.elderflower": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cup.cocoa",
    label: "T.R.N. Limited Drinking Cocoa (Cup)",
    "cup.cocoa": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cup.coffee.dawnlion",
    label: "Dawnlion Coffee (Cup)",
    "cup.coffee.dawnlion": 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cup.coffee.eveningisles",
    label: "Evening Isles Coffee (Cup)",
    "cup.coffee.eveningisles": 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    rose: 1,
    "boost.rose": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cup.scrumpy",
    label: "Scrumpy (Cup)",
    "cup.scrumpy": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cup.tea.assam",
    label: "C&H Second Flush Assam (Cup)",
    "cup.tea.assam": 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "cup.tea.lapsang",
    label: "Veiled Goddess Lapsang Souchong (Cup)",
    "cup.tea.lapsang": 1,
    forge: 2,
    "boost.forge": 2,
    sky: 1,
    "boost.sky": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "eigengrau",
    label: "Eigengrau",
    eigengrau: 1,
    intoxicating: 1,
    ingredient: 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.armagnac",
    label: "Armagnac d'Ys (Glass)",
    "glass.armagnac": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.dandelionwine",
    label: "Dandelion Wine (Glass)",
    "glass.dandelionwine": 1,
    intoxicating: 1,
    ingredient: 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.jannings",
    label: "Schloss Jannings (Glass)",
    "glass.jannings": 1,
    intoxicating: 1,
    ingredient: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.roscraggan",
    label: "Roscraggan Whisky (Glass)",
    "glass.roscraggan": 1,
    intoxicating: 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    rose: 2,
    "boost.rose": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.sloegin",
    label: "Sloe Gin (Glass)",
    "glass.sloegin": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.strathcoyne",
    label: "Strathcoyne Whisky (Glass)",
    "glass.strathcoyne": 1,
    intoxicating: 1,
    ingredient: 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 2,
    "boost.scale": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.water.isle",
    label: "Isle-Water (Glass)",
    "glass.water.isle": 1,
    water: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.water.numa",
    label: "Mist-Kissed Water (Glass)",
    "glass.water.numa": 1,
    water: 1,
    heart: 1,
    "boost.heart": 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "lapsang.sweetened",
    label: "Deep-Sweetened Lapsang (Pot)",
    "lapsang.sweetened": 1,
    distributable: 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 2,
    "boost.nectar": 2,
    sky: 1,
    "boost.sky": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "lapsang.sweetened.cup",
    label: "Deep-Sweetened Lapsang (Cup)",
    "lapsang.sweetened.cup": 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 2,
    "boost.nectar": 2,
    sky: 1,
    "boost.sky": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "lapsang.sweetened.h",
    label: "Deep-Sweetened Lapsang (Half-Pot)",
    "lapsang.sweetened.h": 1,
    distributable: 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 2,
    "boost.nectar": 2,
    sky: 1,
    "boost.sky": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "leathy",
    label: "Leathy",
    leathy: 1,
    intoxicating: 1,
    grail: 2,
    "boost.grail": 2,
    moth: 4,
    "boost.moth": 4,
    nectar: 2,
    "boost.nectar": 2,
    scale: 2,
    "boost.scale": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "leathy.lees",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "liquid.solomon",
    label: "Solomon's Preparation",
    "liquid.solomon": 1,
    moon: 1,
    "boost.moon": 1,
    moth: 1,
    "boost.moth": 1,
    winter: 4,
    "boost.winter": 4,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "liquid.thirza",
    label: "Thirza's Cordials",
    "liquid.thirza": 1,
    intoxicating: 1,
    moth: 2,
    "boost.moth": 2,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "milk",
    label: "Bottle of Milk",
    milk: 1,
    sustenance: 1,
    ingredient: 1,
    "milk.aspect": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pitcher.water.isle",
    label: "Isle-Water (Pitcher)",
    "pitcher.water.isle": 1,
    distributable: 1,
    water: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "pitcher.water.isle.h",
    label: "Isle-Water (Half-Pitcher)",
    "pitcher.water.isle.h": 1,
    distributable: 1,
    water: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pitcher.water.numa",
    label: "Mist-Kissed Water (Pitcher)",
    "pitcher.water.numa": 1,
    distributable: 1,
    water: 1,
    heart: 1,
    "boost.heart": 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pitcher.water.numa.h",
    label: "Mist-Kissed Water (Half-Pitcher)",
    "pitcher.water.numa.h": 1,
    distributable: 1,
    water: 1,
    heart: 1,
    "boost.heart": 1,
    knock: 2,
    "boost.knock": 2,
    moon: 2,
    "boost.moon": 2,
    winter: 1,
    "boost.winter": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.cocoa",
    label: "T.R.N. Limited Drinking Cocoa (Pot)",
    "pot.cocoa": 1,
    distributable: 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.cocoa.h",
    label: "T.R.N. Limited Drinking Cocoa (Half-Pot)",
    "pot.cocoa.h": 1,
    distributable: 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.coffee.dawnlion",
    label: "Dawnlion Coffee (Pot)",
    "pot.coffee.dawnlion": 1,
    distributable: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.coffee.dawnlion.h",
    label: "Dawnlion Coffee (Half-Pot)",
    "pot.coffee.dawnlion.h": 1,
    distributable: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    scale: 1,
    "boost.scale": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.coffee.eveningisles",
    label: "Evening Isles Coffee (Pot)",
    "pot.coffee.eveningisles": 1,
    distributable: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    rose: 1,
    "boost.rose": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "pot.coffee.eveningisles.h",
    label: "Evening Isles Coffee (Half-Pot)",
    "pot.coffee.eveningisles.h": 1,
    distributable: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    rose: 1,
    "boost.rose": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.tea.assam",
    label: "C&H Second Flush Assam (Pot)",
    "pot.tea.assam": 1,
    distributable: 1,
    ingredient: 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.tea.assam.h",
    label: "C&H Second Flush Assam (Half-Pot)",
    "pot.tea.assam.h": 1,
    distributable: 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.tea.lapsang",
    label: "Veiled Goddess Lapsang Souchong  (Pot)",
    "pot.tea.lapsang": 1,
    distributable: 1,
    ingredient: 1,
    forge: 2,
    "boost.forge": 2,
    sky: 1,
    "boost.sky": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.tea.lapsang.h",
    label: "Veiled Goddess Lapsang Souchong (Half-Pot)",
    "pot.tea.lapsang.h": 1,
    distributable: 1,
    forge: 2,
    "boost.forge": 2,
    sky: 1,
    "boost.sky": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pottery.scrumpy",
    label: "Scrumpy",
    "pottery.scrumpy": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pottery.scrumpy.h",
    label: "Scrumpy (Half-Finished)",
    "pottery.scrumpy.h": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 2,
    "boost.nectar": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "rubywise.ruin",
    label: "Rubywise Ruin",
    "rubywise.ruin": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 4,
    "boost.grail": 4,
    heart: 2,
    "boost.heart": 2,
    moth: 2,
    "boost.moth": 2,
    nectar: 2,
    "boost.nectar": 2,
    rose: 2,
    "boost.rose": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "sacrament.ascite",
    label: "Sacrament Ascite",
    "sacrament.ascite": 1,
    intoxicating: 1,
    ingredient: 1,
    knock: 6,
    "boost.knock": 6,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "sacrament.calicite",
    label: "Sacrament Calicite",
    "sacrament.calicite": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 6,
    "boost.grail": 6,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "sacrament.malachite",
    label: "Sacrament Malachite",
    "sacrament.malachite": 1,
    intoxicating: 1,
    ingredient: 1,
    nectar: 6,
    "boost.nectar": 6,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "serpentmilk",
    label: "Serpent-Milk",
    serpentmilk: 1,
    intoxicating: 1,
    edge: 6,
    "boost.edge": 6,
    knock: 2,
    "boost.knock": 2,
    scale: 3,
    "boost.scale": 3,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "old.moment",
  },
  {
    id: "skinshuck.mead",
    label: "Skinshuck Mead",
    "skinshuck.mead": 1,
    intoxicating: 1,
    ingredient: 1,
    heart: 2,
    "boost.heart": 2,
    moth: 6,
    "boost.moth": 6,
    nectar: 2,
    "boost.nectar": 2,
    scale: 2,
    "boost.scale": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "tea.blue.crown",
    label: "Blue Crown Tea (Pot)",
    "tea.blue.crown": 1,
    distributable: 1,
    nectar: 1,
    "boost.nectar": 1,
    sky: 2,
    "boost.sky": 2,
    winter: 2,
    "boost.winter": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.blue.crown.cup",
    label: "Blue Crown Tea (Cup)",
    "tea.blue.crown.cup": 1,
    nectar: 1,
    "boost.nectar": 1,
    sky: 2,
    "boost.sky": 2,
    winter: 2,
    "boost.winter": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.blue.crown.h",
    label: "Blue Crown Tea (Half-Pot)",
    "tea.blue.crown.h": 1,
    distributable: 1,
    nectar: 1,
    "boost.nectar": 1,
    sky: 2,
    "boost.sky": 2,
    winter: 2,
    "boost.winter": 2,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.fragrant.chalice",
    label: "Fragrant Chalice Tea (Pot)",
    "tea.fragrant.chalice": 1,
    distributable: 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.fragrant.chalice.cup",
    label: "Fragrant Chalice Tea (Cup)",
    "tea.fragrant.chalice.cup": 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.fragrant.chalice.h",
    label: "Fragrant Chalice Tea (Half-Pot)",
    "tea.fragrant.chalice.h": 1,
    distributable: 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 1,
    "boost.nectar": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.honeyscar",
    label: "Honeyscar Jasmine Tea (Pot)",
    "tea.honeyscar": 1,
    distributable: 1,
    forge: 2,
    "boost.forge": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.honeyscar.cup",
    label: "Honeyscar Jasmine Tea (Cup)",
    "tea.honeyscar.cup": 1,
    forge: 2,
    "boost.forge": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "tea.honeyscar.h",
    label: "Honeyscar Jasmine Tea (Half-Pot)",
    "tea.honeyscar.h": 1,
    distributable: 1,
    forge: 2,
    "boost.forge": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "witching.tisane",
    label: "Witching Tisane",
    "witching.tisane": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.raveline",
    label: "Domaine Raveline (Bottle)",
    "bottle.raveline": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    scale: 1,
    "boost.scale": 1,
    "beverage.raveline": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.raveline.me",
    label: "Domaine Raveline (Mostly Empty)",
    "bottle.raveline.me": 1,
    distributable: 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    scale: 1,
    "boost.scale": 1,
    "beverage.raveline": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bottle.raveline.mf",
    label: "Domaine Raveline (Mostly Full)",
    "bottle.raveline.mf": 1,
    distributable: 1,
    intoxicating: 1,
    grail: 2,
    "boost.grail": 2,
    scale: 1,
    "boost.scale": 1,
    "beverage.raveline": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "glass.raveline",
    label: "Domaine Raveline (Glass)",
    "glass.raveline": 1,
    intoxicating: 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    scale: 1,
    "boost.scale": 1,
    "beverage.raveline": 1,
    beverage: 1,
    restorative: 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "canvas",
    label: "Canvas",
    canvas: 1,
    blank: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "parchment.anthropoderm",
    label: "Hallowed Anthropoderm",
    "parchment.anthropoderm": 1,
    heart: 2,
    "boost.heart": 2,
    blank: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "parchment.nivine",
    label: "Nivine Parchment",
    "parchment.nivine": 1,
    winter: 1,
    "boost.winter": 1,
    blank: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "quire.paper",
    label: "Quire of Paper",
    "quire.paper": 1,
    fuel: 1,
    nectar: 1,
    "boost.nectar": 1,
    blank: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.ambrose",
    label: "'Ambrose Westcott'",
    unique: true,
    "bust.ambrose": 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.brian",
    label: "'Brian Levinsen'",
    unique: true,
    "bust.brian": 1,
    moth: 1,
    "boost.moth": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.david",
    label: "'Sir David Greene'",
    unique: true,
    "bust.david": 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.eva",
    label: "'Eva Dewulf'",
    unique: true,
    "bust.eva": 1,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.fraser",
    label: "'Fraser Strathcoyne'",
    unique: true,
    "bust.fraser": 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.gervinus",
    label: "'Gervinus van Lauren'",
    unique: true,
    "bust.gervinus": 1,
    knock: 1,
    "boost.knock": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.gideon",
    label: "'Gideon Dewulf'",
    unique: true,
    "bust.gideon": 1,
    heart: 1,
    "boost.heart": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.hendrik",
    label: "'Hendrik Dewulf'",
    unique: true,
    "bust.hendrik": 1,
    edge: 1,
    "boost.edge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.kitty",
    label: "'Kitty Mazarine'",
    unique: true,
    "bust.kitty": 1,
    grail: 1,
    "boost.grail": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.musgrave",
    label: "'Musgrave Dewulf'",
    unique: true,
    "bust.musgrave": 1,
    rose: 1,
    "boost.rose": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.natalia",
    label: "'Natalia Brulleau'",
    unique: true,
    "bust.natalia": 1,
    edge: 1,
    "boost.edge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.serena",
    label: "'Serena Blackwood'",
    unique: true,
    "bust.serena": 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.solomon",
    label: "'Solomon Husher'",
    unique: true,
    "bust.solomon": 1,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.thirza",
    label: "'Thirza Blake'",
    unique: true,
    "bust.thirza": 1,
    nectar: 1,
    "boost.nectar": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.thomas",
    label: "'Thomas Dewulf'",
    unique: true,
    "bust.thomas": 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.valentine",
    label: "'Valentine Dewulf'",
    unique: true,
    "bust.valentine": 1,
    sky: 1,
    "boost.sky": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.walter",
    label: "'Walter Dewulf'",
    unique: true,
    "bust.walter": 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.willem",
    label: "'Willem Harries'",
    unique: true,
    "bust.willem": 1,
    knock: 1,
    "boost.knock": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "abandoned.luggage",
    label: "Abandoned Luggage",
    "abandoned.luggage": 1,
    heart: 1,
    "boost.heart": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "box.oddities",
    label: "Box of Oddities",
    "box.oddities": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "box.rarities",
    label: "Box of Rarities",
    "box.rarities": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "box.records",
    label: "Records Box",
    "box.records": 1,
    "cache.unregarded.rarities": 1,
    nectar: 1,
    "boost.nectar": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "case.attache",
    label: "Attaché Case",
    "case.attache": 1,
    "cache.unregarded.rarities": 1,
    nectar: 1,
    "boost.nectar": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.ambered",
    label: "Ambered Casket",
    "casket.ambered": 1,
    "cache.bright.rarities": 1,
    forge: 1,
    "boost.forge": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.coppery",
    label: "Coppery Casket",
    "casket.coppery": 1,
    "cache.bright.rarities": 1,
    forge: 1,
    "boost.forge": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.hive",
    label: "Hive Casket",
    "casket.hive": 1,
    "cache.unregarded.rarities": 1,
    nectar: 1,
    "boost.nectar": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.imperial",
    label: "Imperial Casket",
    "casket.imperial": 1,
    "cache.sovereign.rarities": 1,
    lantern: 1,
    "boost.lantern": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.ironclad",
    label: "Ironclad Casket",
    "casket.ironclad": 1,
    "cache.bright.rarities": 1,
    forge: 1,
    "boost.forge": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.morbid",
    label: "Morbid Casket",
    "casket.morbid": 1,
    "cache.night.rarities": 1,
    moon: 1,
    "boost.moon": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.mottled",
    label: "Mottled Casket",
    "casket.mottled": 1,
    "cache.unregarded.rarities": 1,
    nectar: 1,
    "boost.nectar": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.royal",
    label: "Royal Casket",
    "casket.royal": 1,
    "cache.sovereign.rarities": 1,
    lantern: 1,
    "boost.lantern": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.scaled",
    label: "Scaled Casket",
    "casket.scaled": 1,
    "cache.night.rarities": 1,
    moon: 1,
    "boost.moon": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "casket.scarred",
    label: "Scarred Casket",
    "casket.scarred": 1,
    "cache.night.rarities": 1,
    moon: 1,
    "boost.moon": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chest.souvenirs",
    label: "Souvenir Cache",
    "chest.souvenirs": 1,
    winter: 1,
    "boost.winter": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "contraband.flotsam",
    label: "Contraband Flotsam",
    "contraband.flotsam": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "contraband.jetsam",
    label: "Contraband Jetsam",
    "contraband.jetsam": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "crate.supplies",
    label: "Crate of Supplies",
    "crate.supplies": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "packages.abandoned",
    label: "Abandoned Packages",
    "packages.abandoned": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "packages.forsaken",
    label: "Forsaken Packages",
    "packages.forsaken": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "packages.lost",
    label: "Lost Packages",
    "packages.lost": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "parcel.slim",
    label: "Slim Parcel",
    "parcel.slim": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "parcel.tall",
    label: "Tall Parcel",
    "parcel.tall": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "suitcase.sb",
    label: "Investigator's Suitcase",
    "suitcase.sb": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 1,
    "boost.rose": 1,
    cache: 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candle.aglaophotis",
    label: "Aglaophotis-Scented Candle",
    "candle.aglaophotis": 1,
    heart: 2,
    "boost.heart": 2,
    knock: 2,
    "boost.knock": 2,
    lantern: 2,
    "boost.lantern": 2,
    rose: 2,
    "boost.rose": 2,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.revelation",
  },
  {
    id: "candle.bedside",
    label: "Bedside Candleholder",
    "candle.bedside": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "candle.bedside.x",
    label: "Weighty Bedside Candleholder",
    "candle.bedside.x": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "precursor.gervinite.fromcandle",
  },
  {
    id: "candle.beeswax",
    label: "Beeswax Candle",
    "candle.beeswax": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candle.bottle",
    label: "Bottled Candle",
    "candle.bottle": 1,
    grail: 1,
    "boost.grail": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "candle.fragrant.chalice",
    label: "Chalice Candle",
    "candle.fragrant.chalice": 1,
    grail: 2,
    "boost.grail": 2,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "candle.historywax",
    label: "Historywax Candle",
    "candle.historywax": 1,
    lantern: 3,
    "boost.lantern": 3,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "wild.surmise",
  },
  {
    id: "candle.holder.snowflake",
    label: "Snowflake Candle",
    "candle.holder.snowflake": 1,
    winter: 1,
    "boost.winter": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "candle.holderblack",
    label: "Widow's Candle",
    "candle.holderblack": 1,
    moon: 1,
    "boost.moon": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.salt",
  },
  {
    id: "candle.holdergold",
    label: "Watchful Candle",
    "candle.holdergold": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "candle.holdersmall",
    label: "Small Candlestick",
    "candle.holdersmall": 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candle.holdertall",
    label: "Tall Candlestick",
    "candle.holdertall": 1,
    lantern: 1,
    "boost.lantern": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candle.honeyscar",
    label: "Honeyscar-Scented Candle",
    "candle.honeyscar": 1,
    forge: 2,
    "boost.forge": 2,
    rose: 1,
    "boost.rose": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "candle.mothorchid",
    label: "Moth-Orchid-Scented Candle",
    "candle.mothorchid": 1,
    knock: 2,
    "boost.knock": 2,
    moth: 1,
    "boost.moth": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.dreamt",
  },
  {
    id: "candle.pyrus",
    label: "Pear-Scented Candle",
    "candle.pyrus": 1,
    forge: 4,
    "boost.forge": 4,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 4,
    "boost.nectar": 4,
    light: 1,
    considerable: 1,
    candle: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "candelabrum.crescent",
    label: "Crescent Candelabrum",
    "candelabrum.crescent": 1,
    lantern: 1,
    "boost.lantern": 1,
    moon: 1,
    "boost.moon": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    comfort: 1,
    consider_spawn_id: "mem.intuition",
  },
  {
    id: "candelabrum.snowflake",
    label: "Snowflake Candelabrum",
    "candelabrum.snowflake": 1,
    lantern: 1,
    "boost.lantern": 1,
    winter: 1,
    "boost.winter": 1,
    light: 1,
    considerable: 1,
    candle: 1,
    comfort: 1,
    consider_spawn_id: "mem.regret",
  },
  {
    id: "armchair.grail",
    label: "Ambrose's Favourite Chair",
    "armchair.grail": 1,
    grail: 1,
    "boost.grail": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "armchair.knock",
    label: "Staff Armchair",
    "armchair.knock": 1,
    knock: 2,
    "boost.knock": 2,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "armchair.librarian",
    label: "Librarian's Armchair",
    "armchair.librarian": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "armchair.moon.a",
    label: "Grand Reading Armchair",
    "armchair.moon.a": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "armchair.moon.b",
    label: "Imposing Reading Armchair",
    "armchair.moon.b": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "armchair.moon.c",
    label: "Nighted Chair",
    "armchair.moon.c": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.fear",
  },
  {
    id: "armchair.sky",
    label: "Kitty's Armchair",
    "armchair.sky": 1,
    sky: 1,
    "boost.sky": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "astrolabe.sky",
    label: "Baron Silence's Astrolabe",
    "astrolabe.sky": 1,
    tool: 1,
    sky: 1,
    "boost.sky": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bag.tricks",
    label: "Bag of Tricks",
    "bag.tricks": 1,
    cache: 1,
    moth: 1,
    "boost.moth": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "boots.morgue",
    label: "Morgue Boots",
    "boots.morgue": 1,
    winter: 1,
    "boost.winter": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "brazier.moon",
    label: "Lunar Brazier",
    "brazier.moon": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bucket.ashes",
    label: "Bucket of Ashes",
    "bucket.ashes": 1,
    material: 1,
    forge: 1,
    "boost.forge": 1,
    comfort: 1,
    considerable: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bucket.mop",
    label: "Mop and Bucket",
    "bucket.mop": 1,
    tool: 1,
    heart: 1,
    "boost.heart": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bucket.seawater",
    label: "Bucket of Seawater",
    "bucket.seawater": 1,
    liquid: 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "chair.bells",
    label: "Bell-Tower Chair",
    "chair.bells": 1,
    forge: 1,
    "boost.forge": 1,
    sky: 2,
    "boost.sky": 2,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.church.atrium",
    label: "Atrium Chair",
    "chair.church.atrium": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.church.heart",
    label: "Restful Seat",
    "chair.church.heart": 1,
    heart: 1,
    "boost.heart": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.church.knock",
    label: "Uncomfortable Seat",
    "chair.church.knock": 1,
    knock: 1,
    "boost.knock": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.church.lantern",
    label: "Contemplative Seat",
    "chair.church.lantern": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.garden1",
    label: "Comfortable Garden Chair",
    "chair.garden1": 1,
    nectar: 1,
    "boost.nectar": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.garden2",
    label: "Restful Garden Chair",
    "chair.garden2": 1,
    nectar: 1,
    "boost.nectar": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.grail.a",
    label: "Greene's Red Chair",
    "chair.grail.a": 1,
    grail: 1,
    "boost.grail": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.grail.b",
    label: "Wine-Dark Chair",
    "chair.grail.b": 1,
    grail: 1,
    "boost.grail": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.grail.c",
    label: "Expansive Chair",
    "chair.grail.c": 1,
    grail: 1,
    "boost.grail": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.gullscry",
    label: "Snug Chair",
    "chair.gullscry": 1,
    heart: 2,
    "boost.heart": 2,
    scale: 2,
    "boost.scale": 2,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.knock",
    label: "Chair of Challenges",
    "chair.knock": 1,
    knock: 1,
    "boost.knock": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "chair.lantern",
    label: "Straw-Cushioned Chair",
    "chair.lantern": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.moon.a",
    label: "Nightsky Chair",
    "chair.moon.a": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.moon.b",
    label: "Starstrewn Chair",
    "chair.moon.b": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.moon.c",
    label: "Twilight Chair",
    "chair.moon.c": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.severe1",
    label: "Severe Chair",
    "chair.severe1": 1,
    edge: 1,
    "boost.edge": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.severe2",
    label: "Spartan Chair",
    "chair.severe2": 1,
    edge: 1,
    "boost.edge": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.sky",
    label: "Melodic Chair",
    "chair.sky": 1,
    sky: 1,
    "boost.sky": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "chair.sky.x",
    label: "Lumpy Melodic Chair",
    "chair.sky.x": 1,
    sky: 1,
    "boost.sky": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "precursor.pale.mommet.fromchair",
  },
  {
    id: "chair.wicker",
    label: "Wicker Chair",
    "chair.wicker": 1,
    heart: 1,
    "boost.heart": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "footstool.grail",
    label: "Inviting Footstool",
    "footstool.grail": 1,
    grail: 1,
    "boost.grail": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "footstool.librarian",
    label: "Librarian's Footstool",
    "footstool.librarian": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "footstool.moon",
    label: "Moon Footstool",
    "footstool.moon": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "gullscry.memorial",
    label: "Valentine's Memorial",
    "gullscry.memorial": 1,
    winter: 3,
    "boost.winter": 3,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "lamp.artdeco",
    label: "Elegant Sunburst Lamp",
    "lamp.artdeco": 1,
    light: 1,
    lantern: 3,
    "boost.lantern": 3,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "lamp.moth",
    label: "Compelling Lamp",
    "lamp.moth": 1,
    light: 1,
    winter: 1,
    "boost.winter": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "lamp.revelation",
    label: "Reading Lamp",
    "lamp.revelation": 1,
    light: 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "pot.bigken",
    label: "Paradise Palm",
    "pot.bigken": 1,
    nectar: 2,
    "boost.nectar": 2,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.watchful",
    label: "Watchful Potted Plant",
    "pot.watchful": 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 1,
    "boost.nectar": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.scent",
  },
  {
    id: "sofa.grail.a",
    label: "Lingering Repose",
    "sofa.grail.a": 1,
    grail: 1,
    "boost.grail": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "sofa.grail.b",
    label: "Delightful Repose",
    "sofa.grail.b": 1,
    grail: 1,
    "boost.grail": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "sofa.grail.b.x",
    label: "Delightful Repose",
    "sofa.grail.b.x": 1,
    grail: 1,
    "boost.grail": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "precursor.spintria.bronze.fromsofa",
  },
  {
    id: "sofa.gullscry",
    label: "Soft Blue Sofa",
    "sofa.gullscry": 1,
    moon: 2,
    "boost.moon": 2,
    sky: 2,
    "boost.sky": 2,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "sofa.knock",
    label: "Chaise-Longue of Conclusions",
    "sofa.knock": 1,
    grail: 1,
    "boost.grail": 1,
    knock: 1,
    "boost.knock": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "sofa.russet",
    label: "Russet Couch",
    "sofa.russet": 1,
    moth: 1,
    "boost.moth": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "sofa.scale",
    label: "Brooding Sofa",
    "sofa.scale": 1,
    scale: 1,
    "boost.scale": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "sofa.winter",
    label: "Sea-Green Sofa",
    "sofa.winter": 1,
    winter: 1,
    "boost.winter": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stand.umbrella",
    label: "Treasury of Shelters",
    "stand.umbrella": 1,
    heart: 1,
    "boost.heart": 1,
    sky: 1,
    "boost.sky": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "statue.crozier",
    label: "'Authority'",
    "statue.crozier": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "statue.debraose",
    label: "'Lady de Braose'",
    "statue.debraose": 1,
    heart: 1,
    "boost.heart": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "statue.rowena",
    label: "'Lady Rowena'",
    "statue.rowena": 1,
    winter: 1,
    "boost.winter": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "stool.gullscry",
    label: "Painter's Stool",
    "stool.gullscry": 1,
    sky: 1,
    "boost.sky": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stool.iron",
    label: "Carpenter's Stool",
    "stool.iron": 1,
    edge: 1,
    "boost.edge": 1,
    moth: 2,
    "boost.moth": 2,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stool.knock",
    label: "Violet Stool",
    "stool.knock": 1,
    knock: 1,
    "boost.knock": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stool.lavender",
    label: "Prison Stool",
    "stool.lavender": 1,
    heart: 2,
    "boost.heart": 2,
    knock: 1,
    "boost.knock": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stool.librarian",
    label: "Librarian's Stool",
    "stool.librarian": 1,
    lantern: 1,
    "boost.lantern": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stool.moon",
    label: "Moon Stool",
    "stool.moon": 1,
    moon: 1,
    "boost.moon": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stool.pale",
    label: "Pale Stool",
    "stool.pale": 1,
    winter: 1,
    "boost.winter": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "stool.plain",
    label: "Plain Stool",
    "stool.plain": 1,
    winter: 1,
    "boost.winter": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "table.cypress",
    label: "Cypress-Wood Table",
    "table.cypress": 1,
    nectar: 1,
    "boost.nectar": 1,
    comfort: 1,
    considerable: 1,
    consider_spawn_id: "mem.scent",
  },
  {
    id: "chronsicord",
    label: "Chronsichord",
    chronsicord: 1,
    ink: 1,
    forge: 3,
    "boost.forge": 3,
    knock: 6,
    "boost.knock": 6,
    sky: 3,
    "boost.sky": 3,
    winter: 3,
    "boost.winter": 3,
    device: 1,
    tool: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.pattern",
  },
  {
    id: "dearday.lens",
    label: "Dearday Lens",
    "dearday.lens": 1,
    lens: 1,
    glass: 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 2,
    "boost.lantern": 2,
    sky: 2,
    "boost.sky": 2,
    device: 1,
    tool: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "flushed.mommet",
    label: "Flushed Mommet",
    "flushed.mommet": 1,
    woven: 1,
    inert: 1,
    grail: 6,
    "boost.grail": 6,
    heart: 3,
    "boost.heart": 3,
    moth: 3,
    "boost.moth": 3,
    device: 1,
    tool: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "pale.mommet",
    label: "Pale Mommet",
    "pale.mommet": 1,
    woven: 1,
    inert: 1,
    grail: 4,
    "boost.grail": 4,
    heart: 2,
    "boost.heart": 2,
    moth: 2,
    "boost.moth": 2,
    device: 1,
    tool: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "egg.chicken",
    label: "Hen's Egg",
    "egg.chicken": 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    egg: 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "egg.gull",
    label: "Gull's Egg",
    "egg.gull": 1,
    brewable: 1,
    scale: 1,
    "boost.scale": 1,
    egg: 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "egg.relic",
    label: "Outsized Egg",
    "egg.relic": 1,
    brewable: 1,
    scale: 3,
    "boost.scale": 3,
    egg: 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.sound",
  },
  {
    id: "egg.viper",
    label: "Viper Egg",
    "egg.viper": 1,
    brewable: 1,
    scale: 1,
    "boost.scale": 1,
    egg: 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "bolt.linen",
    label: "Bolt of Buttercup Linen",
    "bolt.linen": 1,
    lantern: 2,
    "boost.lantern": 2,
    moon: 2,
    "boost.moon": 2,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bolt.silk",
    label: "Bolt of Pale Silk",
    "bolt.silk": 1,
    moth: 2,
    "boost.moth": 2,
    nectar: 2,
    "boost.nectar": 2,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bolt.velvet",
    label: "Bolt of Moss-Green Velvet",
    "bolt.velvet": 1,
    grail: 2,
    "boost.grail": 2,
    winter: 2,
    "boost.winter": 2,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "frithweft",
    label: "Frith-Weft",
    frithweft: 1,
    heart: 3,
    "boost.heart": 3,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "human.hair",
    label: "Human Hair",
    "human.hair": 1,
    remains: 1,
    moth: 1,
    "boost.moth": 1,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "swaddled.thunder",
    label: "Swaddled Thunder",
    "swaddled.thunder": 1,
    fabric: 1,
    heart: 6,
    "boost.heart": 6,
    sky: 4,
    "boost.sky": 4,
    device: 1,
    tool: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "weather.storm",
  },
  {
    id: "wyrdweft",
    label: "Wyrd-Weft",
    wyrdweft: 1,
    heart: 3,
    "boost.heart": 3,
    winter: 6,
    "boost.winter": 6,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "yarns.warm",
    label: "Warmly Coloured Yarns",
    "yarns.warm": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    fabric: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "agave.aeterna",
    label: "Agave Aeterna",
    "agave.aeterna": 1,
    ingredient: 1,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 1,
    "boost.nectar": 1,
    winter: 1,
    "boost.winter": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "aglaophotis",
    label: "Aglaophotis",
    aglaophotis: 1,
    ingredient: 1,
    heart: 2,
    "boost.heart": 2,
    knock: 2,
    "boost.knock": 2,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 2,
    "boost.rose": 2,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "blue.crown",
    label: "Blue Crown",
    "blue.crown": 1,
    ingredient: 1,
    nectar: 1,
    "boost.nectar": 1,
    sky: 2,
    "boost.sky": 2,
    winter: 2,
    "boost.winter": 2,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "fragrant.chalice",
    label: "Fragrant Chalice",
    "fragrant.chalice": 1,
    ingredient: 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 1,
    "boost.nectar": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "honeyscar.jasmine",
    label: "Honeyscar Jasmine",
    "honeyscar.jasmine": 1,
    ingredient: 1,
    forge: 2,
    "boost.forge": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "lenten.rose",
    label: "Lenten Rose",
    "lenten.rose": 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 2,
    "boost.rose": 2,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "moth.orchid",
    label: "Moth Orchid",
    "moth.orchid": 1,
    knock: 2,
    "boost.knock": 2,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.daisies.malachite",
    label: "Pot of Malachite Daisies",
    "pot.daisies.malachite": 1,
    nectar: 2,
    "boost.nectar": 2,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.orchid.pink",
    label: "Potted Pink Orchid",
    "pot.orchid.pink": 1,
    rose: 1,
    "boost.rose": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.orchid.white",
    label: "Potted White Orchid",
    "pot.orchid.white": 1,
    nectar: 1,
    "boost.nectar": 1,
    winter: 1,
    "boost.winter": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.shadowless.silk",
    label: "Shadowless Silk",
    "pot.shadowless.silk": 1,
    lantern: 1,
    "boost.lantern": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "sea.holly",
    label: "Sea Holly",
    "sea.holly": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    winter: 1,
    "boost.winter": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "trumpeters.lily",
    label: "Trumpeter's Lily",
    "trumpeters.lily": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sky: 2,
    "boost.sky": 2,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "vase.amaryllis",
    label: "Vase of Amaryllis",
    "vase.amaryllis": 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 1,
    "boost.nectar": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "vase.bulrushes.golden",
    label: "Vase of Golden Bulrushes",
    "vase.bulrushes.golden": 1,
    moon: 1,
    "boost.moon": 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "vase.carnations",
    label: "Vase of Carnations",
    "vase.carnations": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "vase.lilies",
    label: "Vase of Lilies",
    "vase.lilies": 1,
    nectar: 1,
    "boost.nectar": 1,
    winter: 1,
    "boost.winter": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "vase.roses",
    label: "Vase of Roses",
    "vase.roses": 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 1,
    "boost.nectar": 1,
    flower: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "batter",
    label: "Batter",
    batter: 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "beef",
    label: "Beef",
    beef: 1,
    remains: 1,
    sustenance: 1,
    raw: 1,
    heart: 1,
    "boost.heart": 1,
    scale: 2,
    "boost.scale": 2,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "beef.marinated",
    label: "Marinated Beef (Uncooked)",
    "beef.marinated": 1,
    remains: 1,
    heart: 1,
    "boost.heart": 1,
    scale: 2,
    "boost.scale": 2,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "butter",
    label: "Butter",
    butter: 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "dough",
    label: "Dough",
    dough: 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "dough.cake",
    label: "Cake Batter",
    "dough.cake": 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "dripping",
    label: "Dripping",
    dripping: 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "flour",
    label: "Flour",
    flour: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "mackerel",
    label: "Mackerel",
    mackerel: 1,
    raw: 1,
    remains: 1,
    sustenance: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 2,
    "boost.moon": 2,
    scale: 1,
    "boost.scale": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "marinade.onion",
    label: "Marinated Onions",
    "marinade.onion": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "meringue",
    label: "Meringue",
    meringue: 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    rose: 1,
    "boost.rose": 1,
    sky: 1,
    "boost.sky": 1,
    winter: 1,
    "boost.winter": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pheasant",
    label: "Pheasant",
    pheasant: 1,
    raw: 1,
    remains: 1,
    sustenance: 1,
    heart: 1,
    "boost.heart": 1,
    rose: 1,
    "boost.rose": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pilchards",
    label: "Pilchards",
    pilchards: 1,
    raw: 1,
    remains: 1,
    sustenance: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 2,
    "boost.moon": 2,
    scale: 1,
    "boost.scale": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "potatoes",
    label: "Potatoes",
    potatoes: 1,
    heart: 1,
    "boost.heart": 1,
    winter: 1,
    "boost.winter": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "sugar",
    label: "Sugar",
    sugar: 1,
    grail: 1,
    "boost.grail": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "sugar.creamed",
    label: "Creamed Sugar",
    "sugar.creamed": 1,
    heart: 1,
    "boost.heart": 1,
    ingredient: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "catsclaw",
    label: "Catsclaw",
    catsclaw: 1,
    flower: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "evas.locks",
    label: "Eva's Locks",
    "evas.locks": 1,
    flower: 1,
    rose: 1,
    "boost.rose": 1,
    winter: 1,
    "boost.winter": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "healing.herbs",
    label: "Healing Herbs",
    "healing.herbs": 1,
    flower: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    winter: 1,
    "boost.winter": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "packet.tea.assam",
    label: "C&H Second Flush Assam  (Packet)",
    "packet.tea.assam": 1,
    brewable: 1,
    edge: 1,
    "boost.edge": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "packet.tea.lapsang",
    label: "Veiled Goddess Lapsang Souchong (Packet)",
    "packet.tea.lapsang": 1,
    brewable: 1,
    forge: 1,
    "boost.forge": 1,
    sky: 1,
    "boost.sky": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pot.bamboo",
    label: "Potted Bamboo",
    "pot.bamboo": 1,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.bonsai",
    label: "Tiny Potted Tree",
    "pot.bonsai": 1,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pot.dragon",
    label: "Potted Dragon Tree",
    "pot.dragon": 1,
    scale: 1,
    "boost.scale": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "pot.fern",
    label: "Potted Fern",
    "pot.fern": 1,
    nectar: 2,
    "boost.nectar": 2,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "pot.snake",
    label: "Potted Snake Plant",
    "pot.snake": 1,
    scale: 1,
    "boost.scale": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "pot.swiss",
    label: "Potted Monstera",
    "pot.swiss": 1,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "pot.venus",
    label: "Potted Avidity",
    "pot.venus": 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "vase.gorse",
    label: "Vase of Gorse",
    "vase.gorse": 1,
    forge: 1,
    "boost.forge": 1,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "vase.rushes",
    label: "Vase of Rushes",
    "vase.rushes": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    leaf: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "ampoule.amethyst",
    label: "Amethyst Ampoule",
    "ampoule.amethyst": 1,
    glass: 1,
    heart: 2,
    "boost.heart": 2,
    knock: 2,
    "boost.knock": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "ampoule.wolfsnow",
    label: "Wolf-Snow Ampoule",
    "ampoule.wolfsnow": 1,
    winter: 4,
    "boost.winter": 4,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "ashartine",
    label: "Ashartine",
    ashartine: 1,
    ink: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 6,
    "boost.lantern": 6,
    sky: 2,
    "boost.sky": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "asimel",
    label: "Asimel",
    asimel: 1,
    ink: 1,
    knock: 3,
    "boost.knock": 3,
    moon: 5,
    "boost.moon": 5,
    moth: 1,
    "boost.moth": 1,
    rose: 1,
    "boost.rose": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "azoth",
    label: "Azoth",
    azoth: 1,
    forge: 2,
    "boost.forge": 2,
    knock: 6,
    "boost.knock": 6,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "black.sapphire.wash",
    label: "Black Sapphire Wash",
    "black.sapphire.wash": 1,
    pigment: 1,
    moon: 6,
    "boost.moon": 6,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "catwink",
    label: "Catwink",
    catwink: 1,
    ink: 1,
    edge: 1,
    "boost.edge": 1,
    grail: 1,
    "boost.grail": 1,
    moon: 2,
    "boost.moon": 2,
    scale: 2,
    "boost.scale": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "essence.iotic",
    label: "Iotic Essence",
    "essence.iotic": 1,
    pigment: 1,
    fuel: 1,
    forge: 5,
    "boost.forge": 5,
    lantern: 3,
    "boost.lantern": 3,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "essence.xanthotic",
    label: "Xanthotic Essence",
    "essence.xanthotic": 1,
    pigment: 1,
    forge: 2,
    "boost.forge": 2,
    knock: 2,
    "boost.knock": 2,
    lantern: 5,
    "boost.lantern": 5,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.revelation",
  },
  {
    id: "holiest.hemolymph",
    label: "Holiest Hemolymph",
    "holiest.hemolymph": 1,
    moth: 4,
    "boost.moth": 4,
    nectar: 4,
    "boost.nectar": 4,
    scale: 4,
    "boost.scale": 4,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.impulse",
  },
  {
    id: "houndsgall",
    label: "Houndsgall",
    houndsgall: 1,
    ink: 1,
    edge: 1,
    "boost.edge": 1,
    heart: 2,
    "boost.heart": 2,
    scale: 5,
    "boost.scale": 5,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "ichor.auroral",
    label: "Ichor Auroral",
    "ichor.auroral": 1,
    pigment: 1,
    lantern: 4,
    "boost.lantern": 4,
    rose: 2,
    "boost.rose": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.intuition",
  },
  {
    id: "ichor.vitreous",
    label: "Ichor Vitreous",
    "ichor.vitreous": 1,
    pigment: 1,
    lantern: 4,
    "boost.lantern": 4,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "january.sanguinary",
    label: "January Sanguinary",
    "january.sanguinary": 1,
    heart: 5,
    "boost.heart": 5,
    knock: 3,
    "boost.knock": 3,
    sky: 3,
    "boost.sky": 3,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "music.thunderskin",
  },
  {
    id: "jerry.kerosene",
    label: "Kerosene",
    "jerry.kerosene": 1,
    fuel: 1,
    forge: 3,
    "boost.forge": 3,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "jerry.paraffin",
    label: "Paraffin",
    "jerry.paraffin": 1,
    fuel: 1,
    forge: 2,
    "boost.forge": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "jerry.petrol",
    label: "Petrol",
    "jerry.petrol": 1,
    fuel: 1,
    forge: 2,
    "boost.forge": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "liquid.gideon",
    label: "Gideon's Soaks",
    "liquid.gideon": 1,
    forge: 2,
    "boost.forge": 2,
    heart: 4,
    "boost.heart": 4,
    nectar: 3,
    "boost.nectar": 3,
    winter: 2,
    "boost.winter": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "liquid.regensburg",
    label: "Regensburg Balm",
    "liquid.regensburg": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 2,
    "boost.nectar": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "marakat",
    label: "Marakat",
    marakat: 1,
    encaustum: 1,
    ink: 1,
    grail: 7,
    "boost.grail": 7,
    knock: 7,
    "boost.knock": 7,
    nectar: 7,
    "boost.nectar": 7,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "nillycant",
    label: "Nillycant",
    nillycant: 1,
    encaustum: 1,
    ink: 1,
    edge: 7,
    "boost.edge": 7,
    scale: 7,
    "boost.scale": 7,
    winter: 7,
    "boost.winter": 7,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "oil.forge",
    label: "Scintillate Oil",
    "oil.forge": 1,
    fuel: 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 1,
    "boost.lantern": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "oil.moon",
    label: "Umbrous Oil",
    "oil.moon": 1,
    forge: 1,
    "boost.forge": 1,
    moon: 2,
    "boost.moon": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.intuition",
  },
  {
    id: "oil.moth",
    label: "Oscillate Oil",
    "oil.moth": 1,
    fuel: 1,
    forge: 1,
    "boost.forge": 1,
    moth: 2,
    "boost.moth": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.impulse",
  },
  {
    id: "orpiment.exultant",
    label: "Orpiment Exultant",
    "orpiment.exultant": 1,
    encaustum: 1,
    ink: 1,
    forge: 7,
    "boost.forge": 7,
    heart: 7,
    "boost.heart": 7,
    sky: 7,
    "boost.sky": 7,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "paint.blue",
    label: "Paint: Blue",
    "paint.blue": 1,
    pigment: 1,
    sky: 1,
    "boost.sky": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.blue.dark",
    label: "Paint: Dusk-Blue",
    "paint.blue.dark": 1,
    pigment: 1,
    moon: 1,
    "boost.moon": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.blue.pale",
    label: "Paint: Palest Blue",
    "paint.blue.pale": 1,
    pigment: 1,
    winter: 1,
    "boost.winter": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.bosk",
    label: "Paint: Bosk-Green",
    "paint.bosk": 1,
    pigment: 1,
    nectar: 1,
    "boost.nectar": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.green",
    label: "Paint: Green",
    "paint.green": 1,
    pigment: 1,
    nectar: 1,
    "boost.nectar": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.moth",
    label: "Paint: Moth-Gold",
    "paint.moth": 1,
    pigment: 1,
    moth: 2,
    "boost.moth": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.pink",
    label: "Paint: Pink",
    "paint.pink": 1,
    pigment: 1,
    heart: 1,
    "boost.heart": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.red",
    label: "Paint: Red",
    "paint.red": 1,
    pigment: 1,
    rose: 1,
    "boost.rose": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "paint.yellow",
    label: "Paint: Yellow",
    "paint.yellow": 1,
    pigment: 1,
    lantern: 1,
    "boost.lantern": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "perhibiate",
    label: "Perhibiate",
    perhibiate: 1,
    ink: 1,
    heart: 2,
    "boost.heart": 2,
    lantern: 2,
    "boost.lantern": 2,
    scale: 2,
    "boost.scale": 2,
    winter: 1,
    "boost.winter": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "perinculate",
    label: "Perinculate",
    perinculate: 1,
    ink: 1,
    edge: 4,
    "boost.edge": 4,
    grail: 1,
    "boost.grail": 1,
    scale: 4,
    "boost.scale": 4,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.fear",
  },
  {
    id: "porphyrine",
    label: "Porphyrine",
    porphyrine: 1,
    encaustum: 1,
    ink: 1,
    knock: 7,
    "boost.knock": 7,
    moon: 7,
    "boost.moon": 7,
    rose: 7,
    "boost.rose": 7,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "stargall.ink",
    label: "Stargall Ink",
    "stargall.ink": 1,
    ink: 1,
    forge: 1,
    "boost.forge": 1,
    rose: 1,
    "boost.rose": 1,
    sky: 2,
    "boost.sky": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "toxin.glassfinger",
    label: "Glassfinger Toxin",
    "toxin.glassfinger": 1,
    forge: 2,
    "boost.forge": 2,
    knock: 4,
    "boost.knock": 4,
    lantern: 2,
    "boost.lantern": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "turpentine",
    label: "Turpentine",
    turpentine: 1,
    fuel: 1,
    forge: 1,
    "boost.forge": 1,
    winter: 1,
    "boost.winter": 1,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "uzult",
    label: "Uzult",
    uzult: 1,
    encaustum: 1,
    ink: 1,
    lantern: 7,
    "boost.lantern": 7,
    moth: 7,
    "boost.moth": 7,
    sky: 7,
    "boost.sky": 7,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "yewgall.ink",
    label: "Yewgall Ink",
    "yewgall.ink": 1,
    ink: 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 2,
    "boost.nectar": 2,
    liquid: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dregs",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "bisclavrets.knot",
    label: "Bisclavret's Knot",
    "bisclavrets.knot": 1,
    moth: 1,
    "boost.moth": 1,
    scale: 2,
    "boost.scale": 2,
    mark: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "midnight.mark",
    label: "Midnight Mark",
    "midnight.mark": 1,
    moon: 2,
    "boost.moon": 2,
    moth: 1,
    "boost.moth": 1,
    mark: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "sign.salt",
    label: "Salt-Sign",
    "sign.salt": 1,
    moon: 2,
    "boost.moon": 2,
    rose: 2,
    "boost.rose": 2,
    mark: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "yeartally",
    label: "Year-Tally",
    yeartally: 1,
    winter: 6,
    "boost.winter": 6,
    mark: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "old.moment",
  },
  {
    id: "ambergris",
    label: "Ambergris Chunk",
    ambergris: 1,
    gem: 1,
    moon: 2,
    "boost.moon": 2,
    scale: 2,
    "boost.scale": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "arsenic",
    label: "Arsenic",
    arsenic: 1,
    edge: 1,
    "boost.edge": 1,
    lantern: 1,
    "boost.lantern": 1,
    winter: 1,
    "boost.winter": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.fear",
  },
  {
    id: "atlantic.amber",
    label: "Atlantic Amber",
    "atlantic.amber": 1,
    gem: 1,
    lantern: 3,
    "boost.lantern": 3,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.revelation",
  },
  {
    id: "awakened.feather",
    label: "Awakened Feather",
    "awakened.feather": 1,
    remains: 1,
    scale: 1,
    "boost.scale": 1,
    sky: 2,
    "boost.sky": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "music.cheerful",
  },
  {
    id: "beeswax",
    label: "Beeswax",
    beeswax: 1,
    fuel: 1,
    moth: 1,
    "boost.moth": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "cinnabar",
    label: "Cinnabar",
    cinnabar: 1,
    forge: 1,
    "boost.forge": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "curious.seashell",
    label: "Curious Seashell",
    "curious.seashell": 1,
    moon: 1,
    "boost.moon": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "driftwood.fragment",
    label: "Driftwood Fragment",
    "driftwood.fragment": 1,
    wood: 1,
    fuel: 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "gervinite",
    label: "Gervinite",
    gervinite: 1,
    metal: 1,
    knock: 4,
    "boost.knock": 4,
    rose: 2,
    "boost.rose": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "horizonsight",
  },
  {
    id: "glue",
    label: "Glue",
    glue: 1,
    forge: 1,
    "boost.forge": 1,
    nectar: 1,
    "boost.nectar": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "hawthorn.blank",
    label: "Hawthorn Blank",
    "hawthorn.blank": 1,
    wood: 1,
    fuel: 1,
    knock: 1,
    "boost.knock": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "leathy.lees",
    label: "Leathy Lees",
    "leathy.lees": 1,
    grail: 1,
    "boost.grail": 1,
    moth: 2,
    "boost.moth": 2,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "lignum.vitae.blank",
    label: "Lignum Vitae Blank",
    "lignum.vitae.blank": 1,
    wood: 1,
    fuel: 1,
    edge: 3,
    "boost.edge": 3,
    nectar: 3,
    "boost.nectar": 3,
    scale: 3,
    "boost.scale": 3,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.gossip",
  },
  {
    id: "material.westcott",
    label: "Westcott's Compounds",
    "material.westcott": 1,
    forge: 2,
    "boost.forge": 2,
    grail: 1,
    "boost.grail": 1,
    lantern: 1,
    "boost.lantern": 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "packet.cocoa",
    label: "T.R.N. Limited Drinking Cocoa (Packet)",
    "packet.cocoa": 1,
    brewable: 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "packet.coffee.dawnlion",
    label: "Dawnlion Coffee (Packet)",
    "packet.coffee.dawnlion": 1,
    brewable: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 1,
    "boost.lantern": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "packet.coffee.eveningisles",
    label: "Evening Isles Coffee (Packet)",
    "packet.coffee.eveningisles": 1,
    brewable: 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 1,
    "boost.lantern": 1,
    rose: 1,
    "boost.rose": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pearl.rose",
    label: "Rose-Pearl",
    "pearl.rose": 1,
    gem: 1,
    heart: 1,
    "boost.heart": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "pigment.refulgin",
    label: "Refulgin",
    "pigment.refulgin": 1,
    pigment: 1,
    lantern: 2,
    "boost.lantern": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.revelation",
  },
  {
    id: "quartz.chunk",
    label: "Quartz Chunk",
    "quartz.chunk": 1,
    gem: 1,
    rose: 1,
    "boost.rose": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "rags",
    label: "Rags",
    rags: 1,
    fabric: 1,
    fuel: 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    winter: 1,
    "boost.winter": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "salts.bitterblack",
    label: "Bitterblack Salts",
    "salts.bitterblack": 1,
    pigment: 1,
    forge: 1,
    "boost.forge": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "sand",
    label: "Sand",
    sand: 1,
    glass: 1,
    lantern: 1,
    "boost.lantern": 1,
    moon: 1,
    "boost.moon": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.salt",
  },
  {
    id: "scrapings.phosphorescent",
    label: "Phosphorescent Scrapings",
    "scrapings.phosphorescent": 1,
    remains: 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 2,
    "boost.nectar": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "scraps.wood",
    label: "Wooden Scraps",
    "scraps.wood": 1,
    wood: 1,
    fuel: 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    nectar: 1,
    "boost.nectar": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "seaglass",
    label: "Sea-Glass",
    seaglass: 1,
    glass: 1,
    lantern: 1,
    "boost.lantern": 1,
    moon: 1,
    "boost.moon": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "slab.granite",
    label: "Granite Slab",
    "slab.granite": 1,
    stone: 1,
    forge: 1,
    "boost.forge": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "slab.serpentinite",
    label: "Serpentinite Slab",
    "slab.serpentinite": 1,
    stone: 1,
    knock: 1,
    "boost.knock": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "tanglebrag",
    label: "Tanglebrag",
    tanglebrag: 1,
    lantern: 1,
    "boost.lantern": 1,
    moth: 2,
    "boost.moth": 2,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.impulse",
  },
  {
    id: "tincture.labhitic",
    label: "Labhitic Tincture",
    "tincture.labhitic": 1,
    edge: 2,
    "boost.edge": 2,
    lantern: 1,
    "boost.lantern": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "whispering.sand",
    label: "Whispering Sand",
    "whispering.sand": 1,
    glass: 1,
    lantern: 1,
    "boost.lantern": 1,
    moon: 2,
    "boost.moon": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.salt",
  },
  {
    id: "wire.copper",
    label: "Wire (Copper)",
    "wire.copper": 1,
    metal: 1,
    forge: 2,
    "boost.forge": 2,
    nectar: 1,
    "boost.nectar": 1,
    sky: 1,
    "boost.sky": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "wire.gold",
    label: "Wire (Gold)",
    "wire.gold": 1,
    metal: 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 1,
    "boost.lantern": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "wire.orichalcum",
    label: "Wire (Orichalcum)",
    "wire.orichalcum": 1,
    metal: 1,
    forge: 4,
    "boost.forge": 4,
    lantern: 1,
    "boost.lantern": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "wire.silver",
    label: "Wire (Silver)",
    "wire.silver": 1,
    metal: 1,
    forge: 2,
    "boost.forge": 2,
    moon: 1,
    "boost.moon": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "wire.steel",
    label: "Wire (Steel)",
    "wire.steel": 1,
    metal: 1,
    edge: 1,
    "boost.edge": 1,
    forge: 2,
    "boost.forge": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "wire.tin",
    label: "Wire (Tin)",
    "wire.tin": 1,
    metal: 1,
    forge: 2,
    "boost.forge": 2,
    winter: 1,
    "boost.winter": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "witchworms.desiccated",
    label: "Desiccated Witchworms",
    "witchworms.desiccated": 1,
    remains: 1,
    knock: 2,
    "boost.knock": 2,
    scale: 2,
    "boost.scale": 2,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "yew.blank",
    label: "Yew Blank",
    "yew.blank": 1,
    wood: 1,
    fuel: 1,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    material: 1,
    considerable: 1,
    thing: 1,
    fatigues: "residue",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bittersweet.certainty",
    label: "Bittersweet Certainty",
    unique: true,
    "bittersweet.certainty": 1,
    sound: 1,
    lantern: 1,
    "boost.lantern": 1,
    winter: 2,
    "boost.winter": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "confounding.parable",
    label: "Confounding Parable",
    unique: true,
    "confounding.parable": 1,
    moon: 2,
    "boost.moon": 2,
    rose: 2,
    "boost.rose": 2,
    sky: 2,
    "boost.sky": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.contradiction",
    label: "Memory: Contradiction",
    unique: true,
    "mem.contradiction": 1,
    edge: 2,
    "boost.edge": 2,
    moon: 1,
    "boost.moon": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.dreamt",
    label: "Memory: A Stolen Secret",
    unique: true,
    "mem.dreamt": 1,
    knock: 1,
    "boost.knock": 1,
    moon: 2,
    "boost.moon": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.fear",
    label: "Memory: Fear",
    unique: true,
    "mem.fear": 1,
    edge: 1,
    "boost.edge": 1,
    scale: 2,
    "boost.scale": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.foresight",
    label: "Memory: Foresight",
    unique: true,
    "mem.foresight": 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 1,
    "boost.lantern": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.gossip",
    label: "Memory: Gossip",
    unique: true,
    "mem.gossip": 1,
    grail: 1,
    "boost.grail": 1,
    rose: 2,
    "boost.rose": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.hindsight",
    label: "Memory: Hindsight",
    unique: true,
    "mem.hindsight": 1,
    scale: 1,
    "boost.scale": 1,
    winter: 2,
    "boost.winter": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.impulse",
    label: "Memory: Impulse",
    unique: true,
    "mem.impulse": 1,
    moth: 2,
    "boost.moth": 2,
    nectar: 1,
    "boost.nectar": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.intuition",
    label: "Memory: Intuition",
    unique: true,
    "mem.intuition": 1,
    moon: 2,
    "boost.moon": 2,
    rose: 2,
    "boost.rose": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.loss",
    label: "Memory: Loss",
    unique: true,
    "mem.loss": 1,
    edge: 1,
    "boost.edge": 1,
    winter: 1,
    "boost.winter": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.pattern",
    label: "Memory: Pattern",
    unique: true,
    "mem.pattern": 1,
    forge: 1,
    "boost.forge": 1,
    knock: 2,
    "boost.knock": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.regret",
    label: "Memory: Regret",
    unique: true,
    "mem.regret": 1,
    forge: 1,
    "boost.forge": 1,
    winter: 2,
    "boost.winter": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.revelation",
    label: "Memory: Revelation",
    unique: true,
    "mem.revelation": 1,
    lantern: 2,
    "boost.lantern": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.salt",
    label: "Memory: Salt",
    unique: true,
    "mem.salt": 1,
    knock: 1,
    "boost.knock": 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.satisfaction",
    label: "Memory: Satisfaction",
    unique: true,
    "mem.satisfaction": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.scent",
    label: "Memory: Scent",
    unique: true,
    "mem.scent": 1,
    nectar: 1,
    "boost.nectar": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.sight",
    label: "Memory: Sight",
    unique: true,
    "mem.sight": 1,
    lantern: 1,
    "boost.lantern": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.solace",
    label: "Memory: Solace",
    unique: true,
    "mem.solace": 1,
    heart: 2,
    "boost.heart": 2,
    sky: 1,
    "boost.sky": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.sound",
    label: "Memory: Sound",
    unique: true,
    "mem.sound": 1,
    heart: 1,
    "boost.heart": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.storm",
    label: "Memory: Storm",
    unique: true,
    "mem.storm": 1,
    heart: 2,
    "boost.heart": 2,
    sky: 2,
    "boost.sky": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.taste",
    label: "Memory: Taste",
    unique: true,
    "mem.taste": 1,
    grail: 1,
    "boost.grail": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "mem.touch",
    label: "Memory: Touch",
    unique: true,
    "mem.touch": 1,
    forge: 1,
    "boost.forge": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "music.beguiling",
    label: "Beguiling Melody",
    unique: true,
    "music.beguiling": 1,
    sound: 1,
    grail: 2,
    "boost.grail": 2,
    sky: 2,
    "boost.sky": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "music.cheerful",
    label: "Cheerful Ditty",
    unique: true,
    "music.cheerful": 1,
    sound: 1,
    heart: 2,
    "boost.heart": 2,
    sky: 1,
    "boost.sky": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "music.savage",
    label: "Savage Hymn",
    unique: true,
    "music.savage": 1,
    sound: 1,
    scale: 2,
    "boost.scale": 2,
    sky: 2,
    "boost.sky": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "music.thunderskin",
    label: "Thunderskin's Paean",
    unique: true,
    "music.thunderskin": 1,
    sound: 1,
    "e.preservation": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 4,
    "boost.heart": 4,
    scale: 1,
    "boost.scale": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "music.wistful",
    label: "Wistful Air",
    unique: true,
    "music.wistful": 1,
    sound: 1,
    rose: 2,
    "boost.rose": 2,
    sky: 2,
    "boost.sky": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "old.moment",
    label: "Old Moment",
    unique: true,
    "old.moment": 1,
    "e.preservation": 1,
    lantern: 2,
    "boost.lantern": 2,
    moth: 2,
    "boost.moth": 2,
    scale: 4,
    "boost.scale": 4,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "riddle.nameday",
    label: "Nameday Riddle",
    unique: true,
    "riddle.nameday": 1,
    knock: 2,
    "boost.knock": 2,
    moth: 3,
    "boost.moth": 3,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "secret.threshold",
    label: "Secret Threshold",
    unique: true,
    "secret.threshold": 1,
    knock: 2,
    "boost.knock": 2,
    rose: 1,
    "boost.rose": 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "torgues.cleansing",
    label: "Torgue's Cleansing",
    unique: true,
    "torgues.cleansing": 1,
    edge: 2,
    "boost.edge": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "wild.surmise",
    label: "Wild Surmise",
    unique: true,
    "wild.surmise": 1,
    "e.ithastry": 1,
    lantern: 3,
    "boost.lantern": 3,
    moth: 3,
    "boost.moth": 3,
    sky: 3,
    "boost.sky": 3,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "windrumour",
    label: "Wind-Rumour",
    unique: true,
    windrumour: 1,
    omen: 1,
    "e.birdsong": 1,
    heart: 1,
    "boost.heart": 1,
    sky: 2,
    "boost.sky": 2,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "winning.move",
    label: "Winning Move",
    unique: true,
    "winning.move": 1,
    "e.illumination": 1,
    edge: 3,
    "boost.edge": 3,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "ascendant.harmony",
    label: "Ascendant Harmony",
    unique: true,
    "ascendant.harmony": 1,
    sound: 1,
    "e.birdsong": 1,
    lantern: 2,
    "boost.lantern": 2,
    sky: 4,
    "boost.sky": 4,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "curious.hunch",
    label: "Curious Hunch",
    unique: true,
    "curious.hunch": 1,
    omen: 1,
    "e.nyctodromy": 1,
    heart: 3,
    "boost.heart": 3,
    knock: 4,
    "boost.knock": 4,
    lantern: 3,
    "boost.lantern": 3,
    moth: 3,
    "boost.moth": 3,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "didumos",
    label: "Didumos",
    unique: true,
    didumos: 1,
    "e.hushery": 1,
    "e.horomachistry": 1,
    knock: 3,
    "boost.knock": 3,
    lantern: 3,
    "boost.lantern": 3,
    sky: 6,
    "boost.sky": 6,
    winter: 3,
    "boost.winter": 3,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "earthsign",
    label: "Earth-Sign",
    unique: true,
    earthsign: 1,
    omen: 1,
    "e.skolekosophy": 1,
    nectar: 2,
    "boost.nectar": 2,
    scale: 2,
    "boost.scale": 2,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "enduring.reflection",
    label: "Enduring Reflection",
    unique: true,
    "enduring.reflection": 1,
    "e.nyctodromy": 1,
    heart: 1,
    "boost.heart": 1,
    knock: 1,
    "boost.knock": 1,
    rose: 3,
    "boost.rose": 3,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "forbidden.epic",
    label: "Forbidden Epic",
    unique: true,
    "forbidden.epic": 1,
    "e.horomachistry": 1,
    "e.birdsong": 1,
    edge: 6,
    "boost.edge": 6,
    moon: 4,
    "boost.moon": 4,
    rose: 4,
    "boost.rose": 4,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "horizonsight",
    label: "Horizon-Sight",
    unique: true,
    horizonsight: 1,
    "e.hushery": 1,
    rose: 4,
    "boost.rose": 4,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "invincible.audacity",
    label: "Invincible Audacity",
    unique: true,
    "invincible.audacity": 1,
    "e.illumination": 1,
    "e.ithastry": 1,
    edge: 6,
    "boost.edge": 6,
    forge: 3,
    "boost.forge": 3,
    lantern: 3,
    "boost.lantern": 3,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "music.hive",
    label: "Hive's Lament",
    unique: true,
    "music.hive": 1,
    sound: 1,
    "e.bosk": 1,
    moth: 2,
    "boost.moth": 2,
    nectar: 4,
    "boost.nectar": 4,
    winter: 2,
    "boost.winter": 2,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "name.earthquake",
    label: "Earthquake Name",
    unique: true,
    "name.earthquake": 1,
    omen: 1,
    "e.ithastry": 1,
    "e.skolekosophy": 1,
    forge: 3,
    "boost.forge": 3,
    scale: 6,
    "boost.scale": 6,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "occult.scrap",
    label: "Occult Scrap",
    unique: true,
    "occult.scrap": 1,
    omen: 1,
    "e.horomachistry": 1,
    knock: 2,
    "boost.knock": 2,
    moth: 2,
    "boost.moth": 2,
    rose: 2,
    "boost.rose": 2,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "old.wound",
    label: "Old Wound",
    unique: true,
    "old.wound": 1,
    edge: 1,
    "boost.edge": 1,
    moon: 2,
    "boost.moon": 2,
    winter: 3,
    "boost.winter": 3,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "windinwaiting",
    label: "Wind-in-Waiting",
    unique: true,
    windinwaiting: 1,
    "e.birdsong": 1,
    "e.bosk": 1,
    grail: 3,
    "boost.grail": 3,
    moth: 3,
    "boost.moth": 3,
    scale: 3,
    "boost.scale": 3,
    sky: 6,
    "boost.sky": 6,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "wormwood.dream",
    label: "Wormwood Dream",
    unique: true,
    "wormwood.dream": 1,
    omen: 1,
    "e.skolekosophy": 1,
    "e.nyctodromy": 1,
    edge: 3,
    "boost.edge": 3,
    moon: 6,
    "boost.moon": 6,
    winter: 6,
    "boost.winter": 6,
    memory: 1,
    persistent: 1,
    fatigues: "echo",
  },
  {
    id: "numen.alte",
    label: "Numen: Merciless Alteration",
    "numen.alte": 1,
    edge: 5,
    "boost.edge": 5,
    forge: 5,
    "boost.forge": 5,
    grail: 5,
    "boost.grail": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.asce",
    label: "Numen: the Paths of the Sun",
    "numen.asce": 1,
    forge: 5,
    "boost.forge": 5,
    knock: 5,
    "boost.knock": 5,
    lantern: 5,
    "boost.lantern": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.bala",
    label: "Numen: Back Into Balance",
    "numen.bala": 1,
    heart: 5,
    "boost.heart": 5,
    sky: 5,
    "boost.sky": 5,
    winter: 5,
    "boost.winter": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.bell",
    label: "Numen: the Bells of Ys",
    "numen.bell": 1,
    edge: 5,
    "boost.edge": 5,
    forge: 5,
    "boost.forge": 5,
    rose: 5,
    "boost.rose": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.conf",
    label: "Numen: Inescapable Confinement",
    "numen.conf": 1,
    knock: 5,
    "boost.knock": 5,
    scale: 5,
    "boost.scale": 5,
    winter: 5,
    "boost.winter": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.desc",
    label: "Numen: the Sun's Weakness",
    "numen.desc": 1,
    grail: 5,
    "boost.grail": 5,
    lantern: 5,
    "boost.lantern": 5,
    moth: 5,
    "boost.moth": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.feas",
    label: "Numen: an Irresistible Feast",
    "numen.feas": 1,
    edge: 5,
    "boost.edge": 5,
    grail: 5,
    "boost.grail": 5,
    nectar: 5,
    "boost.nectar": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.loop",
    label: "Numen: Loopholes",
    "numen.loop": 1,
    knock: 5,
    "boost.knock": 5,
    moon: 5,
    "boost.moon": 5,
    moth: 5,
    "boost.moth": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.oldl",
    label: "Numen: That Old Lost Music",
    "numen.oldl": 1,
    rose: 5,
    "boost.rose": 5,
    scale: 5,
    "boost.scale": 5,
    sky: 5,
    "boost.sky": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.secr",
    label: "Numen: the Great Counterfeit",
    "numen.secr": 1,
    lantern: 5,
    "boost.lantern": 5,
    moon: 5,
    "boost.moon": 5,
    nectar: 5,
    "boost.nectar": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.thre",
    label: "Numen: Three Rules",
    "numen.thre": 1,
    heart: 5,
    "boost.heart": 5,
    moth: 5,
    "boost.moth": 5,
    scale: 5,
    "boost.scale": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.unde",
    label: "Numen: a Final Understanding",
    "numen.unde": 1,
    rose: 5,
    "boost.rose": 5,
    sky: 5,
    "boost.sky": 5,
    winter: 5,
    "boost.winter": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "numen.worl",
    label: "Numen: Weaving the World",
    "numen.worl": 1,
    heart: 5,
    "boost.heart": 5,
    moon: 5,
    "boost.moon": 5,
    nectar: 5,
    "boost.nectar": 5,
    memory: 1,
    numen: 1,
    persistent: 1,
    fatigues: "echo",
    consider_spawn_id: "mem.hindsight",
  },
  {
    id: "animal.bones",
    label: "Animal Bones",
    "animal.bones": 1,
    scale: 2,
    "boost.scale": 2,
    winter: 1,
    "boost.winter": 1,
    remains: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.fear",
  },
  {
    id: "essential.periost",
    label: "Essential Periost",
    "essential.periost": 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 4,
    "boost.nectar": 4,
    scale: 4,
    "boost.scale": 4,
    winter: 4,
    "boost.winter": 4,
    remains: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "old.moment",
  },
  {
    id: "jar.heart",
    label: "Heart in a Jar",
    "jar.heart": 1,
    heart: 2,
    "boost.heart": 2,
    winter: 1,
    "boost.winter": 1,
    remains: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.fear",
  },
  {
    id: "liquid.sample",
    label: "Sample Jar",
    "liquid.sample": 1,
    knock: 2,
    "boost.knock": 2,
    winter: 1,
    "boost.winter": 1,
    remains: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "skaptodon.fang",
    label: "Skaptodon Fang",
    "skaptodon.fang": 1,
    edge: 2,
    "boost.edge": 2,
    scale: 2,
    "boost.scale": 2,
    remains: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.foresight",
  },
  {
    id: "urn.ashes",
    label: "Urn of Ashes",
    "urn.ashes": 1,
    winter: 3,
    "boost.winter": 3,
    remains: 1,
    considerable: 1,
    thing: 1,
    fatigues: "dust",
    consider_spawn_id: "mem.fear",
  },
  {
    id: "spintria.bronze",
    label: "Bronze Spintria",
    "spintria.bronze": 1,
    forge: 2,
    "boost.forge": 2,
    tally: 2,
    ductile: 1,
    rank: 50,
  },
  {
    id: "spintria.gold",
    label: "Gold Spintria",
    "spintria.gold": 1,
    lantern: 5,
    "boost.lantern": 5,
    tally: 5,
    ductile: 1,
    rank: 50,
  },
  {
    id: "spintria.iron",
    label: "Iron Spintria",
    "spintria.iron": 1,
    edge: 1,
    "boost.edge": 1,
    tally: 1,
    ductile: 1,
    rank: 50,
  },
  {
    id: "spintria.silver",
    label: "Silver Spintria",
    "spintria.silver": 1,
    grail: 4,
    "boost.grail": 4,
    tally: 4,
    ductile: 1,
    rank: 50,
  },
  {
    id: "spintria.tin",
    label: "Tin Spintria",
    "spintria.tin": 1,
    heart: 3,
    "boost.heart": 3,
    tally: 3,
    ductile: 1,
    rank: 50,
  },
  {
    id: "almonds",
    label: "Almonds",
    almonds: 1,
    "course.side": 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    moth: 1,
    "boost.moth": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "apple.charlotte",
    label: "Apple Charlotte",
    "apple.charlotte": 1,
    "course.pudding": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "bake.ham.potato",
    label: "Ham and Potato Bake",
    "bake.ham.potato": 1,
    "course.main": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "bake.mushroom.potato",
    label: "Mushroom & Potato Bake",
    "bake.mushroom.potato": 1,
    "course.main": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "beef.roast",
    label: "Roast Beef",
    "beef.roast": 1,
    "course.main": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    scale: 2,
    "boost.scale": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "beef.roast.marinated",
    label: "Marinated Roast Beef",
    "beef.roast.marinated": 1,
    "course.main": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    scale: 2,
    "boost.scale": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "blackberries",
    label: "Blackberries",
    blackberries: 1,
    "course.first": 1,
    ingredient: 1,
    fruit: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "bread.crusty",
    label: "Crusty Bread",
    "bread.crusty": 1,
    "course.side": 1,
    ingredient: 1,
    bread: 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "bread.eggy",
    label: "Eggy Bread",
    "bread.eggy": 1,
    "course.first": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "bread.pillas",
    label: "Pillas-Oat Bread",
    "bread.pillas": 1,
    bread: 1,
    "course.first": 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.sight",
  },
  {
    id: "cake.blackberry",
    label: "Blackberry Sponge Cake",
    "cake.blackberry": 1,
    "course.pudding": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "cake.honey",
    label: "Cornish Honey Cake",
    "cake.honey": 1,
    "course.pudding": 1,
    heart: 2,
    "boost.heart": 2,
    lantern: 2,
    "boost.lantern": 2,
    moth: 2,
    "boost.moth": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "cake.knot",
    label: "Knot-Cake",
    "cake.knot": 1,
    "course.pudding": 1,
    edge: 2,
    "boost.edge": 2,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    lantern: 1,
    "boost.lantern": 1,
    moth: 3,
    "boost.moth": 3,
    nectar: 2,
    "boost.nectar": 2,
    scale: 3,
    "boost.scale": 3,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "cake.madeira",
    label: "Madeira Cake",
    "cake.madeira": 1,
    "course.pudding": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    lantern: 1,
    "boost.lantern": 1,
    moth: 1,
    "boost.moth": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "cake.rosehip",
    label: "Rosehip Sponge Cake",
    "cake.rosehip": 1,
    "course.pudding": 1,
    heart: 2,
    "boost.heart": 2,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "casserole.ham.egg",
    label: "Ham and Egg Casserole",
    "casserole.ham.egg": 1,
    "course.main": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    moth: 1,
    "boost.moth": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "chips.game",
    label: "Game Chips",
    "chips.game": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    knock: 1,
    "boost.knock": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "croquettes.egg",
    label: "Egg Croquettes",
    "croquettes.egg": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 2,
    "boost.scale": 2,
    sky: 2,
    "boost.sky": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "croutons.plum",
    label: "Plum Croutons",
    "croutons.plum": 1,
    "course.pudding": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "egg.boiled",
    label: "Boiled Egg",
    "egg.boiled": 1,
    "course.first": 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "egg.scrambled",
    label: "Scrambled Egg",
    "egg.scrambled": 1,
    "course.first": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "floating.island",
    label: "Floating Island",
    "floating.island": 1,
    "course.pudding": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    rose: 1,
    "boost.rose": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "fruit.bowl.pears",
    label: "Bowl of Sea-Blest Pears",
    "fruit.bowl.pears": 1,
    ingredient: 1,
    fruit: 1,
    grail: 1,
    "boost.grail": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "fruit.misshapen",
    label: "Misshapen Fruit",
    "fruit.misshapen": 1,
    fruit: 1,
    heart: 1,
    "boost.heart": 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "fudge",
    label: "Fudge",
    fudge: 1,
    "course.pudding": 1,
    grail: 3,
    "boost.grail": 3,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "grapes",
    label: "Bunch of Grapes",
    grapes: 1,
    ingredient: 1,
    fruit: 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "ham.canned",
    label: "Canned Ham",
    "ham.canned": 1,
    remains: 1,
    ingredient: 1,
    heart: 2,
    "boost.heart": 2,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "honey",
    label: "Honey",
    honey: 1,
    liquid: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "honey.cuckoo",
    label: "Cuckoo-Honey",
    "honey.cuckoo": 1,
    liquid: 1,
    ingredient: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    knock: 1,
    "boost.knock": 1,
    moth: 3,
    "boost.moth": 3,
    nectar: 2,
    "boost.nectar": 2,
    scale: 3,
    "boost.scale": 3,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "old.moment",
  },
  {
    id: "jam.blackberry",
    label: "Blackberry Jam",
    "jam.blackberry": 1,
    ingredient: 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "jam.rosehip",
    label: "Rosehip Jam",
    "jam.rosehip": 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 2,
    "boost.rose": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "leek.gratin",
    label: "Leek Gratin",
    "leek.gratin": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mackerel.kedgeree",
    label: "Kedgeree",
    "mackerel.kedgeree": 1,
    "course.first": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    moon: 1,
    "boost.moon": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mackerel.montecarlo",
    label: "Mackerel Monte Carlo",
    "mackerel.montecarlo": 1,
    "course.first": 1,
    heart: 2,
    "boost.heart": 2,
    moon: 1,
    "boost.moon": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mackerel.pickled",
    label: "Pickled Mackerel",
    "mackerel.pickled": 1,
    "course.first": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 2,
    "boost.moon": 2,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mackerel.poached",
    label: "Poached Mackerel",
    "mackerel.poached": 1,
    "course.first": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    moon: 1,
    "boost.moon": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mackerel.soused",
    label: "Soused Mackerel",
    "mackerel.soused": 1,
    "course.first": 1,
    heart: 2,
    "boost.heart": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "marrow.stuffed.acrid",
    label: "Stuffed Acrid Marrow",
    "marrow.stuffed.acrid": 1,
    "course.first": 1,
    "course.main": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "marrow.stuffed.dark",
    label: "Stuffed Dark Marrow",
    "marrow.stuffed.dark": 1,
    "course.first": 1,
    "course.main": 1,
    heart: 2,
    "boost.heart": 2,
    moon: 1,
    "boost.moon": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "marrow.stuffed.golden",
    label: "Stuffed Golden Marrow",
    "marrow.stuffed.golden": 1,
    "course.first": 1,
    "course.main": 1,
    heart: 2,
    "boost.heart": 2,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "marrow.stuffed.pale",
    label: "Stuffed Pale Marrow",
    "marrow.stuffed.pale": 1,
    "course.first": 1,
    "course.main": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "meringue.apple",
    label: "Baked Apple Meringue",
    "meringue.apple": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 2,
    "boost.grail": 2,
    nectar: 1,
    "boost.nectar": 1,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "meringue.mushroom",
    label: "Mushroom Meringue",
    "meringue.mushroom": 1,
    "course.pudding": 1,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "meringue.pear",
    label: "Baked Pear Meringue",
    "meringue.pear": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 2,
    "boost.grail": 2,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "meringue.ys",
    label: "Walls-of-Ys",
    "meringue.ys": 1,
    "course.pudding": 1,
    forge: 4,
    "boost.forge": 4,
    grail: 2,
    "boost.grail": 2,
    knock: 2,
    "boost.knock": 2,
    nectar: 4,
    "boost.nectar": 4,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "horizonsight",
  },
  {
    id: "moly",
    label: "Moly",
    moly: 1,
    root: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 2,
    "boost.moon": 2,
    moth: 2,
    "boost.moth": 2,
    nectar: 1,
    "boost.nectar": 1,
    scale: 2,
    "boost.scale": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.impulse",
  },
  {
    id: "moly.aujus",
    label: "Moly au Jus",
    "moly.aujus": 1,
    "course.first": 1,
    "course.side": 1,
    heart: 2,
    "boost.heart": 2,
    moon: 2,
    "boost.moon": 2,
    moth: 2,
    "boost.moth": 2,
    nectar: 1,
    "boost.nectar": 1,
    scale: 2,
    "boost.scale": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mushrooms",
    label: "Mushrooms",
    mushrooms: 1,
    raw: 1,
    ingredient: 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "mushrooms.pickled",
    label: "Pickled Mushrooms",
    "mushrooms.pickled": 1,
    "course.first": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "onion.gratin",
    label: "Onion Gratin",
    "onion.gratin": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "onion.rings",
    label: "Onion Rings",
    "onion.rings": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "orange.jumble",
    label: "Orange Jumble",
    "orange.jumble": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    lantern: 1,
    "boost.lantern": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pear.belle.helene",
    label: "Poire Belle Hélène",
    "pear.belle.helene": 1,
    "course.pudding": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pears.ys",
    label: "Poires Ys",
    "pears.ys": 1,
    "course.pudding": 1,
    forge: 4,
    "boost.forge": 4,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    nectar: 4,
    "boost.nectar": 4,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pheasant.jugged",
    label: "Jugged Pheasant",
    "pheasant.jugged": 1,
    "course.main": 1,
    edge: 1,
    "boost.edge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    rose: 1,
    "boost.rose": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pheasant.roast",
    label: "Roast Pheasant",
    "pheasant.roast": 1,
    "course.main": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    rose: 1,
    "boost.rose": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pheasant.roast.salad.grape",
    label: "Cold Pheasant with Grape Salad",
    "pheasant.roast.salad.grape": 1,
    "course.first": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.apples",
    label: "Apple Pie",
    "pie.apples": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.pears",
    label: "Pear Pie",
    "pie.pears": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.cottage",
    label: "Cottage Pie",
    "pie.cottage": 1,
    "course.main": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 2,
    "boost.scale": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.game",
    label: "Game Pie",
    "pie.game": 1,
    "course.main": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    knock: 1,
    "boost.knock": 1,
    moth: 1,
    "boost.moth": 1,
    rose: 1,
    "boost.rose": 1,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.kingsluck",
    label: "Kingsluck Pie",
    "pie.kingsluck": 1,
    "course.main": 1,
    forge: 2,
    "boost.forge": 2,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.pilchards",
    label: "Starygazy Pie",
    "pie.pilchards": 1,
    "course.main": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    scale: 1,
    "boost.scale": 1,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.pumpkin",
    label: "Pumpkin Pie",
    "pie.pumpkin": 1,
    "course.main": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.pumpkin.amber",
    label: "Amber Pumpkin Pie",
    "pie.pumpkin.amber": 1,
    "course.pudding": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.pumpkin.honey",
    label: "Honey-Haunted Pumpkin Pie",
    "pie.pumpkin.honey": 1,
    "course.pudding": 1,
    "course.main": 1,
    edge: 2,
    "boost.edge": 2,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    knock: 1,
    "boost.knock": 1,
    moth: 3,
    "boost.moth": 3,
    nectar: 2,
    "boost.nectar": 2,
    scale: 3,
    "boost.scale": 3,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.sea",
    label: "Sea-Pie",
    "pie.sea": 1,
    "course.main": 1,
    ingredient: 1,
    forge: 1,
    "boost.forge": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pie.vegetable.spring",
    label: "Steamed Spring Vegetable Pie",
    "pie.vegetable.spring": 1,
    "course.main": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 2,
    "boost.nectar": 2,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "stew.vegetables",
    label: "Vegetable Stew",
    "stew.vegetables": 1,
    "course.main": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pilchards.pickled",
    label: "Pickled Pilchards",
    "pilchards.pickled": 1,
    "course.first": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 2,
    "boost.moon": 2,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "plums",
    label: "Plums",
    plums: 1,
    "course.first": 1,
    ingredient: 1,
    fruit: 1,
    heart: 1,
    "boost.heart": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "potatoes.roast",
    label: "Roast Potatoes",
    "potatoes.roast": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 2,
    "boost.heart": 2,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "potatoes.roast.magnificent",
    label: "Magnificent Roast Potatoes",
    "potatoes.roast.magnificent": 1,
    "course.side": 1,
    edge: 1,
    "boost.edge": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pudding.toffee",
    label: "Toffee Pudding",
    "pudding.toffee": 1,
    "course.pudding": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 2,
    "boost.heart": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pudding.yorkshire",
    label: "Yorkshire Pudding",
    "pudding.yorkshire": 1,
    "course.side": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "pumpkin",
    label: "Pumpkin",
    pumpkin: 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "pumpkin.amber",
    label: "Amber Pumpkin",
    "pumpkin.amber": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "pumpkin.amber.x",
    label: "Soft Amber Pumpkin",
    "pumpkin.amber.x": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "precursor.honey.cuckoo.frompumpkin",
  },
  {
    id: "pumpkin.wormy",
    label: "Wormy Pumpkin",
    "pumpkin.wormy": 1,
    raw: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "pyrus.auricalcinus",
    label: "Pyrus Auricalcinus",
    "pyrus.auricalcinus": 1,
    ingredient: 1,
    fruit: 1,
    forge: 4,
    "boost.forge": 4,
    nectar: 4,
    "boost.nectar": 4,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "rosehips",
    label: "Rosehips",
    rosehips: 1,
    "course.first": 1,
    ingredient: 1,
    fruit: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "sack.vegetables",
    label: "Sack of Vegetables",
    ambits: {
      "sack.vegetables": 1,
    },
    "sack.vegetables": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.scent",
  },
  {
    id: "salad.grape",
    label: "Grape Salad",
    "salad.grape": 1,
    "course.first": 1,
    "course.side": 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 1,
    "boost.nectar": 1,
    rose: 1,
    "boost.rose": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "sandwiches.egg",
    label: "Egg Sandwiches",
    "sandwiches.egg": 1,
    "course.first": 1,
    heart: 2,
    "boost.heart": 2,
    scale: 1,
    "boost.scale": 1,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "souffle.aglaophotis",
    label: "Aglaophotis Soufflé",
    "souffle.aglaophotis": 1,
    "course.pudding": 1,
    heart: 2,
    "boost.heart": 2,
    knock: 2,
    "boost.knock": 2,
    lantern: 2,
    "boost.lantern": 2,
    nectar: 1,
    "boost.nectar": 1,
    rose: 2,
    "boost.rose": 2,
    sky: 1,
    "boost.sky": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "horizonsight",
  },
  {
    id: "soup.leek",
    label: "Leek Soup",
    "soup.leek": 1,
    "course.first": 1,
    edge: 1,
    "boost.edge": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "soup.onion",
    label: "Onion Soup",
    "soup.onion": 1,
    "course.first": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 2,
    "boost.heart": 2,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "soup.pumpkin",
    label: "Pumpkin Soup",
    "soup.pumpkin": 1,
    "course.first": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "soup.pumpkin.amber",
    label: "Amber Pumpkin Soup",
    "soup.pumpkin.amber": 1,
    "course.first": 1,
    heart: 1,
    "boost.heart": 1,
    lantern: 1,
    "boost.lantern": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "soup.pumpkin.honey",
    label: "Honey-Haunted Pumpkin Soup",
    "soup.pumpkin.honey": 1,
    "course.first": 1,
    edge: 2,
    "boost.edge": 2,
    heart: 2,
    "boost.heart": 2,
    knock: 1,
    "boost.knock": 1,
    moon: 1,
    "boost.moon": 1,
    moth: 3,
    "boost.moth": 3,
    nectar: 2,
    "boost.nectar": 2,
    scale: 3,
    "boost.scale": 3,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "toastie.ham.cheese",
    label: "Ham and Cheese Toastie",
    "toastie.ham.cheese": 1,
    "course.first": 1,
    forge: 1,
    "boost.forge": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "toastie.mushroom",
    label: "Fried Mushrooms on Toast",
    "toastie.mushroom": 1,
    "course.first": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "toastie.pilchards",
    label: "Pilchards on Toast",
    "toastie.pilchards": 1,
    "course.first": 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 1,
    "boost.nectar": 1,
    scale: 1,
    "boost.scale": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "veg.basket",
    label: "Basket of Vegetables",
    "veg.basket": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "veg.basket.apples",
    label: "Basket of Apples",
    "veg.basket.apples": 1,
    ingredient: 1,
    fruit: 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "veg.basket.leeks",
    label: "Basket of Leeks",
    "veg.basket.leeks": 1,
    raw: 1,
    ingredient: 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "veg.basket.onions",
    label: "Basket of Onions",
    "veg.basket.onions": 1,
    raw: 1,
    ingredient: 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "veg.marrow.acrid",
    label: "Acrid Marrow",
    "veg.marrow.acrid": 1,
    raw: 1,
    ingredient: 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.regret",
  },
  {
    id: "veg.marrow.dark",
    label: "Dark Marrow",
    "veg.marrow.dark": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    moon: 1,
    "boost.moon": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "veg.marrow.golden",
    label: "Golden Marrow",
    "veg.marrow.golden": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    lantern: 1,
    "boost.lantern": 1,
    nectar: 2,
    "boost.nectar": 2,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.solace",
  },
  {
    id: "veg.marrow.pale",
    label: "Pale Marrow",
    "veg.marrow.pale": 1,
    raw: 1,
    ingredient: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.taste",
  },
  {
    id: "whip.prune",
    label: "Prune Whip",
    "whip.prune": 1,
    "course.pudding": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    nectar: 1,
    "boost.nectar": 1,
    sustenance: 1,
    considerable: 1,
    thing: 1,
    fatigues: "scraps",
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "chart.genealogical",
    label: "Genealogical Chart",
    "chart.genealogical": 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "clock.artdeco",
    label: "Brazen Clock",
    "clock.artdeco": 1,
    forge: 1,
    "boost.forge": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "hours.sister",
    label: "'The Sister-and-Witch'",
    "hours.sister": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 2,
    "boost.heart": 2,
    moth: 2,
    "boost.moth": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "hours.thunderskin",
    label: "'The Thunderskin'",
    "hours.thunderskin": 1,
    heart: 2,
    "boost.heart": 2,
    sky: 2,
    "boost.sky": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "hours.velvet",
    label: "'The Velvet'",
    "hours.velvet": 1,
    moon: 2,
    "boost.moon": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "hours.witch",
    label: "'The Witch-and-Sister'",
    "hours.witch": 1,
    grail: 2,
    "boost.grail": 2,
    heart: 1,
    "boost.heart": 1,
    moth: 2,
    "boost.moth": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirror.fractured",
    label: "Fractured Mirror",
    "mirror.fractured": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirror.frost",
    label: "Frosty Mirror",
    "mirror.frost": 1,
    lantern: 1,
    "boost.lantern": 1,
    winter: 1,
    "boost.winter": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirror.night",
    label: "Night Mirror",
    "mirror.night": 1,
    lantern: 1,
    "boost.lantern": 1,
    moon: 1,
    "boost.moon": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirror.shaving",
    label: "Shaving Mirror",
    "mirror.shaving": 1,
    lantern: 1,
    "boost.lantern": 1,
    moth: 1,
    "boost.moth": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirror.silver",
    label: "Silvery Mirror",
    "mirror.silver": 1,
    moon: 1,
    "boost.moon": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirror.storm",
    label: "Storm-Tossed Mirror",
    "mirror.storm": 1,
    lantern: 1,
    "boost.lantern": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "motley1.portrait1",
    label: "'Our Benefactor'",
    "motley1.portrait1": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "motley1.portrait2",
    label: "'Our Benefactress'",
    "motley1.portrait2": 1,
    forge: 1,
    "boost.forge": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "motto.bureau",
    label: "ALIIS LICET TIBI NON LICET",
    "motto.bureau": 1,
    knock: 1,
    "boost.knock": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.annointing",
    label: "'An Anointing'",
    "painting.annointing": 1,
    moth: 1,
    "boost.moth": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.behatted",
    label: "'Portrait of a Behatted Lady'",
    "painting.behatted": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.birds",
    label: "'Departure'",
    "painting.birds": 1,
    moth: 2,
    "boost.moth": 2,
    winter: 2,
    "boost.winter": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.bridge.ortucchio",
    label: "'The Bridge at Ortucchio'",
    "painting.bridge.ortucchio": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.chiliarch.victory",
    label: "The Chiliarch's Victory'",
    "painting.chiliarch.victory": 1,
    edge: 1,
    "boost.edge": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.fear",
  },
  {
    id: "painting.cockatoo",
    label: "'Chac'",
    "painting.cockatoo": 1,
    nectar: 2,
    "boost.nectar": 2,
    sky: 2,
    "boost.sky": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.coupleinthelibrary",
    label: "'Love in a Quiet Place'",
    "painting.coupleinthelibrary": 1,
    grail: 1,
    "boost.grail": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.donkey",
    label: "'The Tattered Outlaw'",
    "painting.donkey": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.dontmesswithladyeva",
    label: "'Eva and Abraham, 1724'",
    "painting.dontmesswithladyeva": 1,
    grail: 1,
    "boost.grail": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.edge",
    label: "'The First Threshold'",
    "painting.edge": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.forge",
    label: "'The First End'",
    "painting.forge": 1,
    forge: 1,
    "boost.forge": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.grail",
    label: "'The First Birth'",
    "painting.grail": 1,
    grail: 1,
    "boost.grail": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.heart",
    label: "'The Foundlings'",
    "painting.heart": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.julian",
    label: "'Julian Coseley'",
    "painting.julian": 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.knock",
    label: "'A Bargain'",
    "painting.knock": 1,
    knock: 1,
    "boost.knock": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.lantern",
    label: "'Glory's Gift'",
    "painting.lantern": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.mansus",
    label: "'The Mansus'",
    "painting.mansus": 1,
    knock: 2,
    "boost.knock": 2,
    lantern: 2,
    "boost.lantern": 2,
    moth: 2,
    "boost.moth": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.mihail.altar",
    label: "Mihail in Glory",
    "painting.mihail.altar": 1,
    "hidden.mihail.altar": 1,
    forge: 2,
    "boost.forge": 2,
    lantern: 2,
    "boost.lantern": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.revelation",
  },
  {
    id: "painting.mihail.sarcophagus",
    label: "Mihail in Chains",
    "painting.mihail.sarcophagus": 1,
    "hidden.mihail.sarcophagus": 1,
    lantern: 2,
    "boost.lantern": 2,
    winter: 2,
    "boost.winter": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.regret",
  },
  {
    id: "painting.moon",
    label: "'The Wheel Still Turns'",
    "painting.moon": 1,
    moon: 1,
    "boost.moon": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.morgen",
    label: "'Mlle Matutine'",
    "painting.morgen": 1,
    grail: 1,
    "boost.grail": 1,
    moon: 1,
    "boost.moon": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.moth",
    label: "'The First Answer'",
    "painting.moth": 1,
    moth: 1,
    "boost.moth": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.mountainlake",
    label: "'To Hear Those Voices'",
    "painting.mountainlake": 1,
    moon: 2,
    "boost.moon": 2,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.munday",
    label: "'Lord Munday'",
    "painting.munday": 1,
    grail: 1,
    "boost.grail": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.nectar",
    label: "'Gods Return'",
    "painting.nectar": 1,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.owl",
    label: "'The Watcher'",
    "painting.owl": 1,
    knock: 2,
    "boost.knock": 2,
    lantern: 2,
    "boost.lantern": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.picasso1",
    label: "'Red, Blue'",
    "painting.picasso1": 1,
    grail: 1,
    "boost.grail": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.picasso2",
    label: "'To Be Fruitful'",
    "painting.picasso2": 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.poplars",
    label: "'Raveline Summer'",
    "painting.poplars": 1,
    forge: 1,
    "boost.forge": 1,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.rose",
    label: "Caer Ys",
    "painting.rose": 1,
    rose: 1,
    "boost.rose": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.sacrifice",
    label: "'A Sacrifice'",
    "painting.sacrifice": 1,
    grail: 1,
    "boost.grail": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.scale",
    label: "'The Hatching'",
    "painting.scale": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.serena",
    label: "'Dr Serena Blackwood'",
    "painting.serena": 1,
    forge: 1,
    "boost.forge": 1,
    rose: 1,
    "boost.rose": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.sky",
    label: "'Self-Born'",
    "painting.sky": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.sky.b",
    label: "'As Above, So Below'",
    "painting.sky.b": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.teeny2",
    label: "'Crowcross Sands at High Tide'",
    "painting.teeny2": 1,
    moon: 1,
    "boost.moon": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.teeny3",
    label: "'The Boy Prays'",
    "painting.teeny3": 1,
    grail: 1,
    "boost.grail": 1,
    moon: 1,
    "boost.moon": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.thecalm",
    label: "'Sedona, Not Yet'",
    "painting.thecalm": 1,
    moth: 2,
    "boost.moth": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.thekiss",
    label: "'Again, at Night'",
    "painting.thekiss": 1,
    grail: 1,
    "boost.grail": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.tree.teeny",
    label: "'Leaves in the Wind'",
    "painting.tree.teeny": 1,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.tryphon",
    label: "'Lady Tryphon'",
    "painting.tryphon": 1,
    grail: 2,
    "boost.grail": 2,
    moth: 1,
    "boost.moth": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "painting.winter",
    label: "'Supplication'",
    "painting.winter": 1,
    winter: 1,
    "boost.winter": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "shield.drake.red",
    label: "Red Drake Shield",
    "shield.drake.red": 1,
    heart: 1,
    "boost.heart": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "shield.lion.golden",
    label: "Golden Lion Shield",
    "shield.lion.golden": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "shield.stag.green",
    label: "Green Stag Shield",
    "shield.stag.green": 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stag.finnian",
    label: "Finnian",
    "stag.finnian": 1,
    carcass: 1,
    scale: 2,
    "boost.scale": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "stag.hokobald",
    label: "Hokobald",
    "stag.hokobald": 1,
    carcass: 1,
    scale: 2,
    "boost.scale": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "stag.philemon",
    label: "Philemon",
    "stag.philemon": 1,
    carcass: 1,
    scale: 2,
    "boost.scale": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "stag.tavish",
    label: "Tavish",
    "stag.tavish": 1,
    carcass: 1,
    scale: 2,
    "boost.scale": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "symbol.solinvictis",
    label: "Sol Invictis Symbol",
    "symbol.solinvictis": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "tapestry.thefoundationofthesun",
    label: "'The Foundation of the Sun'",
    "tapestry.thefoundationofthesun": 1,
    woven: 1,
    winter: 2,
    "boost.winter": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "trophy.deer.red",
    label: "Red Deer Antlers",
    "trophy.deer.red": 1,
    carcass: 1,
    scale: 2,
    "boost.scale": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "trophy.yeth.hound",
    label: "Yeth-Hound Horns",
    "trophy.yeth.hound": 1,
    carcass: 1,
    grail: 1,
    "boost.grail": 1,
    scale: 2,
    "boost.scale": 2,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "weapon.bow.hunter",
    label: "Hunter's Bow",
    "weapon.bow.hunter": 1,
    wooden: 1,
    sky: 1,
    "boost.sky": 1,
    winter: 1,
    "boost.winter": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.bow.poacher",
    label: "Poacher's Bow",
    "weapon.bow.poacher": 1,
    wooden: 1,
    rose: 1,
    "boost.rose": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.bow.sentry",
    label: "Sentry's Bow",
    "weapon.bow.sentry": 1,
    wooden: 1,
    lantern: 1,
    "boost.lantern": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.crossbow",
    label: "Crossbow",
    "weapon.crossbow": 1,
    wooden: 1,
    forge: 1,
    "boost.forge": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.foil.dearday",
    label: "Dearday's Foil",
    "weapon.foil.dearday": 1,
    edge: 2,
    "boost.edge": 2,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.foil.torgue",
    label: "Torgue's Foil",
    "weapon.foil.torgue": 1,
    edge: 2,
    "boost.edge": 2,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.leaf.grail",
    label: "Red Practice Sword",
    "weapon.leaf.grail": 1,
    Wooden: 1,
    edge: 1,
    "boost.edge": 1,
    grail: 1,
    "boost.grail": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.scent",
  },
  {
    id: "weapon.leaf.moth",
    label: "Dappled Practice Sword",
    "weapon.leaf.moth": 1,
    wooden: 1,
    edge: 1,
    "boost.edge": 1,
    moth: 1,
    "boost.moth": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "weapon.pistols.flintlock",
    label: "Matched Flintlock Pistols",
    "weapon.pistols.flintlock": 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.practice.azita",
    label: "Azita's Practice Sword",
    "weapon.practice.azita": 1,
    wooden: 1,
    edge: 2,
    "boost.edge": 2,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.practice.fraser",
    label: "Fraser's Practice Sword",
    "weapon.practice.fraser": 1,
    wooden: 1,
    edge: 1,
    "boost.edge": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.practice.grail",
    label: "Red Quarterstaff",
    "weapon.practice.grail": 1,
    Wooden: 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.scent",
  },
  {
    id: "weapon.practice.greene",
    label: "Greene's Practice Sword",
    "weapon.practice.greene": 1,
    wooden: 1,
    edge: 1,
    "boost.edge": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.practice.mehrdad",
    label: "Mehrad's Practice Sword",
    "weapon.practice.mehrdad": 1,
    wooden: 1,
    edge: 2,
    "boost.edge": 2,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.practice.moth",
    label: "Dappled Quarterstaff",
    "weapon.practice.moth": 1,
    wooden: 1,
    moth: 1,
    "boost.moth": 1,
    nectar: 1,
    "boost.nectar": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "weapon.practice.natalia",
    label: "Natalia's Practice Sword",
    "weapon.practice.natalia": 1,
    wooden: 1,
    edge: 1,
    "boost.edge": 1,
    lantern: 1,
    "boost.lantern": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapon.swords.sebastian",
    label: "Sebastian's Swords",
    "weapon.swords.sebastian": 1,
    knife: 1,
    edge: 1,
    "boost.edge": 1,
    moon: 1,
    "boost.moon": 1,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weapons.td.bokken",
    label: "Bokken: Captain Torgue and Mistress Dearday",
    "weapons.td.bokken": 1,
    edge: 2,
    "boost.edge": 2,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.contradiction",
  },
  {
    id: "weapons.td.cudgels",
    label: "Cudgels: Dyddgu and St Twrog",
    "weapons.td.cudgels": 1,
    edge: 2,
    "boost.edge": 2,
    forge: 2,
    "boost.forge": 2,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.contradiction",
  },
  {
    id: "weapons.td.wasters",
    label: "Wasters: Darling-Dear and Father Turk",
    "weapons.td.wasters": 1,
    edge: 2,
    "boost.edge": 2,
    sky: 1,
    "boost.sky": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.contradiction",
  },
  {
    id: "wings.grail",
    label: "Lepidoptery Display (Grail-centric)",
    "wings.grail": 1,
    grail: 1,
    "boost.grail": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "wings.heart",
    label: "Lepidoptery Display (Heart-centric)",
    "wings.heart": 1,
    heart: 1,
    "boost.heart": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "wings.moth",
    label: "Lepidoptery Display (Moth-centric)",
    "wings.moth": 1,
    moth: 1,
    "boost.moth": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "wings.scale",
    label: "Lepidoptery Display (Scale-centric)",
    "wings.scale": 1,
    scale: 1,
    "boost.scale": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "wings.winter",
    label: "Lepidoptery Display (Winter-centric)",
    "wings.winter": 1,
    winter: 1,
    "boost.winter": 1,
    wallart: 1,
    considerable: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "axe.aspect.xenodice",
    label: "Aspect of the Axe: Xenodice Half-Faced",
    "axe.aspect.xenodice": 1,
    fixed: 1,
    knock: 2,
    "boost.knock": 2,
  },
  {
    id: "dartboard",
    label: "Dartboard",
    dartboard: 1,
    fixed: 1,
    edge: 1,
    "boost.edge": 1,
    moth: 1,
    "boost.moth": 1,
    sky: 1,
    "boost.sky": 1,
  },
  {
    id: "grail.aspect.lagiah",
    label: "Aspect of the Grail: Lagiah, the Queen Unsated",
    "grail.aspect.lagiah": 1,
    fixed: 1,
    grail: 2,
    "boost.grail": 2,
    consider_spawn_id: "mem.satisfaction",
  },
  {
    id: "key.hooks",
    label: "Key Hooks",
    "key.hooks": 1,
    fixed: 1,
    knock: 1,
    "boost.knock": 1,
  },
  {
    id: "malachite.aspect.mylissa",
    label: "Aspect of the Malachite: Mylissa, Queen and Palace",
    "malachite.aspect.mylissa": 1,
    fixed: 1,
    nectar: 2,
    "boost.nectar": 2,
  },
  {
    id: "ship.model.kerisham",
    label: "HMS Kerisham",
    "ship.model.kerisham": 1,
    fixed: 1,
    edge: 1,
    "boost.edge": 1,
    moon: 1,
    "boost.moon": 1,
    winter: 1,
    "boost.winter": 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "window.madrugad",
    label: "Stained Glass Window: the Madrugad",
    "window.madrugad": 1,
    fixed: 1,
    forge: 1,
    "boost.forge": 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "window.meniscate",
    label: "Stained Glass Window: the Meniscate",
    "window.meniscate": 1,
    fixed: 1,
    moon: 1,
    "boost.moon": 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "window.suninrags",
    label: "Stained Glass Window: the Sun-in-Rags",
    "window.suninrags": 1,
    fixed: 1,
    winter: 1,
    "boost.winter": 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "window.watchman",
    label: "Stained Glass Window: the Watchman",
    "window.watchman": 1,
    fixed: 1,
    lantern: 1,
    "boost.lantern": 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "basket.laundry",
    label: "Basket of Dirty Laundry",
    "basket.laundry": 1,
    woven: 1,
    soiled: 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "basket.linen",
    label: "Basket of Clean Linen",
    "basket.linen": 1,
    woven: 1,
    restorative: 1,
    heart: 1,
    "boost.heart": 1,
    considerable: 1,
    thing: 1,
    fatigues: "basket.laundry",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "basket.towels",
    label: "Basket of Towels",
    "basket.towels": 1,
    woven: 1,
    heart: 2,
    "boost.heart": 2,
    considerable: 1,
    thing: 1,
    fatigues: "basket.towels.damp",
    consider_spawn_id: "mem.touch",
  },
  {
    id: "basket.towels.damp",
    label: "Basket of Damp Towels",
    icon: "basket.towels",
    "basket.towels.damp": 1,
    soaked: 1,
    woven: 1,
    heart: 2,
    "boost.heart": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "book.press",
    label: "Book Press",
    "book.press": 1,
    tool: 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bowls.kitchen",
    label: "Kitchen Bowls",
    "bowls.kitchen": 1,
    tool: 1,
    kitchenware: 1,
    heart: 1,
    "boost.heart": 1,
    nectar: 1,
    "boost.nectar": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "burette.cucurbit",
    label: "Cucurbit Burette",
    "burette.cucurbit": 1,
    tool: 1,
    edge: 1,
    "boost.edge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.abbot.geffrey",
    label: "'Abbot Geffrey'",
    unique: true,
    "bust.abbot.geffrey": 1,
    knock: 1,
    "boost.knock": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.abbot.thomas",
    label: "'Abbot Thomas'",
    unique: true,
    "bust.abbot.thomas": 1,
    moth: 1,
    "boost.moth": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.abduction.salvation",
    label: "'Abduction, Salvation'",
    "bust.abduction.salvation": 1,
    grail: 1,
    "boost.grail": 1,
    knock: 1,
    "boost.knock": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.abra",
    label: "Pale Bust",
    unique: true,
    "bust.abra": 1,
    moon: 1,
    "boost.moon": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.knot.moon",
    label: "Goddess-who-drinks-light",
    "bust.knot.moon": 1,
    moon: 1,
    "boost.moon": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.knot.moth",
    label: "Goddess-who-changes-skin",
    "bust.knot.moth": 1,
    moth: 1,
    "boost.moth": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.knotabbess",
    label: "'SISTER'",
    "bust.knotabbess": 1,
    grail: 1,
    "boost.grail": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "bust.medical",
    label: "Reference Image",
    "bust.medical": 1,
    heart: 2,
    "boost.heart": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "bust.melancthe",
    label: "'St Melancthe'",
    unique: true,
    "bust.melancthe": 1,
    lantern: 2,
    "boost.lantern": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candelabra.meteoric.iron",
    label: "Meteoric Iron Candelabra",
    "candelabra.meteoric.iron": 1,
    light: 1,
    edge: 1,
    "boost.edge": 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candle.holderthree",
    label: "Tall Candelabra",
    "candle.holderthree": 1,
    light: 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "candle.holderthree.persian",
    label: "Persian Candelabra",
    "candle.holderthree.persian": 1,
    light: 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "chess.set",
    label: "Lacquered Bone Chess Set",
    "chess.set": 1,
    edge: 2,
    "boost.edge": 2,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "clock.forge",
    label: "Daybreak Clock",
    "clock.forge": 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "clock.knock",
    label: "Stepstrike Clock",
    "clock.knock": 1,
    knock: 2,
    "boost.knock": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "clock.lantern",
    label: "Masquewatch Clock",
    "clock.lantern": 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "clock.librarian",
    label: "Librarian's Timepiece",
    "clock.librarian": 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "clock.moon",
    label: "Ninewink Clock",
    "clock.moon": 1,
    moon: 1,
    "boost.moon": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "clock.servants",
    label: "Inscribed Clock",
    "clock.servants": 1,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "compasses.forge",
    label: "Compasses",
    "compasses.forge": 1,
    tool: 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "disc.fishes",
    label: "Twinned-Fish Stone",
    "disc.fishes": 1,
    moon: 1,
    "boost.moon": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "face.faceless",
    label: "Half-Faceless Face",
    "face.faceless": 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "glasses.librarian",
    label: "Librarian's Glasses",
    "glasses.librarian": 1,
    light: 1,
    glass: 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "globe.lunar",
    label: "Lunar Globe",
    "globe.lunar": 1,
    tool: 1,
    moon: 1,
    "boost.moon": 1,
    rose: 1,
    "boost.rose": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "globe.watchman",
    label: "Watchman's Globe",
    "globe.watchman": 1,
    lantern: 1,
    "boost.lantern": 1,
    rose: 1,
    "boost.rose": 1,
    sky: 1,
    "boost.sky": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "hourglass.scale.g",
    label: "Serpent-Styled Glass",
    "hourglass.scale.g": 1,
    tool: 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "hourglass.scale.w",
    label: "Serpent-Styled Glass",
    "hourglass.scale.w": 1,
    tool: 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "jar.snootle",
    label: "Snootle Jar",
    "jar.snootle": 1,
    tool: 1,
    lantern: 1,
    "boost.lantern": 1,
    moth: 1,
    "boost.moth": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "key.hush.house",
    label: "Hush House Key",
    unique: true,
    "key.hush.house": 1,
    key: 1,
    knock: 3,
    "boost.knock": 3,
    winter: 3,
    "boost.winter": 3,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "knife.thirza",
    label: "Bronze Knife",
    "knife.thirza": 1,
    knife: 1,
    tool: 1,
    edge: 1,
    "boost.edge": 1,
    grail: 1,
    "boost.grail": 1,
    nectar: 2,
    "boost.nectar": 2,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "lamp.fringed",
    label: "Fringed Lamp",
    "lamp.fringed": 1,
    light: 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "lamp.hurricane",
    label: "Hurricane Lamp",
    "lamp.hurricane": 1,
    light: 1,
    lantern: 1,
    "boost.lantern": 1,
    sky: 1,
    "boost.sky": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "lamp.table.edge",
    label: "Strategist's Lamp",
    "lamp.table.edge": 1,
    light: 1,
    edge: 1,
    "boost.edge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "lamp.table.grail",
    label: "Cyprian's Lamp",
    "lamp.table.grail": 1,
    light: 1,
    grail: 1,
    "boost.grail": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "lamp.table.rose",
    label: "Cartographer's Lamp",
    "lamp.table.rose": 1,
    light: 1,
    rose: 1,
    "boost.rose": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mazarine.fife",
    label: "Mazarine Fife",
    "mazarine.fife": 1,
    tool: 1,
    instrument: 1,
    sky: 3,
    "boost.sky": 3,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sound",
  },
  {
    id: "menorah",
    label: "Regensburg Menorah",
    menorah: 1,
    light: 1,
    heart: 1,
    "boost.heart": 1,
    lantern: 2,
    "boost.lantern": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mirrorscope",
    label: "Mirrorscope",
    mirrorscope: 1,
    tool: 1,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "mortar.pestle",
    label: "Mortar & Pestle",
    "mortar.pestle": 1,
    tool: 1,
    forge: 1,
    "boost.forge": 1,
    nectar: 1,
    "boost.nectar": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "newspaper.yellowing",
    label: "Yellowing Newspaper",
    "newspaper.yellowing": 1,
    rose: 1,
    "boost.rose": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "occult.scrap",
  },
  {
    id: "pot.twilight",
    label: "Twilight Pot",
    unique: true,
    "pot.twilight": 1,
    moon: 1,
    "boost.moon": 1,
    sky: 1,
    "boost.sky": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "saw",
    label: "Saw",
    saw: 1,
    tool: 1,
    edge: 1,
    "boost.edge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "scales.spice",
    label: "Spice Scales",
    "scales.spice": 1,
    tool: 1,
    kitchenware: 1,
    spicing: 1,
    grail: 1,
    "boost.grail": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "shears.sisterhood",
    label: "Shears of the Sisterhood",
    "shears.sisterhood": 1,
    tool: 1,
    moth: 1,
    "boost.moth": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "skull",
    label: "Cranial Tchotchke",
    skull: 1,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "skull.contained",
    label: "Contained Skull",
    "skull.contained": 1,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "skull.x",
    label: "Glinting Cranial Tchotchke",
    "skull.x": 1,
    rose: 1,
    "boost.rose": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "precursor.dearday.lens.fromskull",
  },
  {
    id: "spanners",
    label: "Spanners",
    spanners: 1,
    tool: 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "square.forge",
    label: "Square",
    "square.forge": 1,
    tool: 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "statue.matilda.white",
    label: "White Matilda",
    "statue.matilda.white": 1,
    winter: 2,
    "boost.winter": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "statuette.bobo.nectar",
    label: "Bobos of Spring",
    "statuette.bobo.nectar": 1,
    nectar: 1,
    "boost.nectar": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "statuette.cat.scale",
    label: "Cat of Depths",
    "statuette.cat.scale": 1,
    scale: 1,
    "boost.scale": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "statuette.owl.moth",
    label: "Owl of Spirals",
    "statuette.owl.moth": 1,
    knock: 1,
    "boost.knock": 1,
    moth: 1,
    "boost.moth": 1,
    rose: 1,
    "boost.rose": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "statuette.pigeon",
    label: "Pigeon Statuette",
    "statuette.pigeon": 1,
    sky: 1,
    "boost.sky": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "statuette.velvet",
    label: "'The Velvet'",
    "statuette.velvet": 1,
    moon: 2,
    "boost.moon": 2,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "stone.indecipherable",
    label: "Inscribed Stone",
    "stone.indecipherable": 1,
    covenant: 1,
    lantern: 3,
    "boost.lantern": 3,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "typewriter",
    label: "Typewriter",
    typewriter: 1,
    tool: 1,
    ink: 1,
    forge: 1,
    "boost.forge": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "typewriter.winter",
    label: "Silent Typewriter",
    "typewriter.winter": 1,
    tool: 1,
    ink: 1,
    winter: 1,
    "boost.winter": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "vase.redlotus",
    label: "Red Lotus Vase",
    "vase.redlotus": 1,
    grail: 1,
    "boost.grail": 1,
    heart: 1,
    "boost.heart": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "wateringcan",
    label: "Watering Can",
    wateringcan: 1,
    tool: 1,
    nectar: 1,
    "boost.nectar": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.sight",
  },
  {
    id: "weapon.hendrik",
    label: "Hendrik's Blade",
    "weapon.hendrik": 1,
    knife: 1,
    edge: 2,
    "boost.edge": 2,
    lantern: 1,
    "boost.lantern": 1,
    considerable: 1,
    thing: 1,
    consider_spawn_id: "mem.touch",
  },
  {
    id: "weather.rain",
    label: "Rain",
    "weather.rain": 1,
    nectar: 2,
    grail: 2,
    "boost.nectar": 2,
    "boost.grail": 2,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.snow",
    label: "Snow",
    "weather.snow": 1,
    winter: 3,
    sky: 3,
    "boost.winter": 3,
    "boost.sky": 3,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.storm",
    label: "Storm",
    icon: "mem.storm",
    "weather.storm": 1,
    heart: 4,
    sky: 4,
    "boost.heart": 4,
    "boost.sky": 4,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.fog",
    label: "Fog",
    "weather.fog": 1,
    knock: 3,
    moon: 3,
    "boost.knock": 3,
    "boost.moon": 3,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.numa",
    label: "Nume-Brume",
    "weather.numa": 1,
    knock: 5,
    moon: 5,
    rose: 5,
    winter: 5,
    "boost.knock": 5,
    "boost.moon": 5,
    "boost.rose": 5,
    "boost.winter": 5,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.hail",
    label: "Hail",
    "weather.hail": 1,
    edge: 3,
    sky: 3,
    "boost.edge": 3,
    "boost.sky": 3,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.gale",
    label: "Gale",
    "weather.gale": 1,
    heart: 3,
    sky: 3,
    "boost.heart": 3,
    "boost.sky": 3,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.sunny",
    label: "Sunny",
    "weather.sunny": 1,
    lantern: 2,
    sky: 2,
    "boost.lantern": 2,
    "boost.sky": 2,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.clouds",
    label: "Clouds",
    "weather.clouds": 1,
    moth: 1,
    moon: 1,
    "boost.moth": 1,
    "boost.moon": 1,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
  {
    id: "weather.earthquake",
    label: "Earthquake",
    "weather.earthquake": 1,
    scale: 5,
    edge: 5,
    "boost.scale": 5,
    "boost.edge": 5,
    weather: 1,
    memory: 1,
    fatigues: "echo",
  },
] as Item[];
